var CHART_ETA;
let searchTimeout = null;
var markerLoadCount = 0;
const IMAGE_ASSET_VERSION = Date.now();

function appendImageVersion(url) {
  if (!url) return url;
  return `${url}${url.includes('?') ? '&' : '?'}v=${IMAGE_ASSET_VERSION}`;
}

$(document).ready(function () {
  //loadDataGrafikTimeTravel('');
  //loadDataPeriodeGrafikTimeTravel('', '');
  $('#btn-search-eta').on('click', function () {
    const stratDate = $('#filter-periode-start').val();
    const endDate = $('#filter-periode-end').val();
    loadDataPeriodeGrafikTimeTravel(stratDate, endDate);
  });
  // Debounce agar tidak terlalu sering terpanggil saat mengetik

  // Tambahkan ID pada input search agar mudah di-select
  // (Pastikan di HTML: ganti <input ...> menjadi <input id="input-search-sidebar" ...>)
  // Jika belum diubah di HTML, selector di bawah tetap bisa pakai placeholder
  $(document).on('input', '#input-search-sidebar', function () {
    clearTimeout(searchTimeout);
    const keyword = $(this).val();
    searchTimeout = setTimeout(function () {
      filterSidebarCards(keyword);
      console.log(`filter data: ${keyword}`);
    }, 300); // delay 300ms
  });

  // Reset filter saat tab berganti (agar hasil filter tab lama tidak mengganggu)
  $('#tab-center-left a[data-bs-toggle="tab"]').on('shown.bs.tab', function () {
    const keyword = $('#input-search-sidebar').val() || '';
    filterSidebarCards(keyword);
  });

  //initMapLayerFilter();
});

function onMarkerLoadComplete() {
  markerLoadCount++;
  // Tunggu AWLR + ARR + WQ selesai (3 fungsi)
  if (markerLoadCount >= 3) {
    initMapLayerFilter();
  }
}

let StartDate = flatpickr('#filter-periode-start', {
  dateFormat: 'Y-m-d', // '04 Januari 2023' format
  defaultDate: 'today', // Set default date to today
  locale: 'id', // Indonesian locale
  maxDate: 'today',
  // Add other options and configurations as needed
  altInput: true, // Enable alternate input
  altFormat: 'd F Y', // 'YYYY-MM-DD' format for hidden input
  onChange: function (selectedDates, dateStr, instance) {
    // Set minDate of end date picker based on selected start date
    EndDate.set('minDate', dateStr);
  },
});

let EndDate = flatpickr('#filter-periode-end', {
  dateFormat: 'Y-m-d', // '04 Januari 2023' format
  defaultDate: 'today', // Set default date to today
  locale: 'id', // Indonesian locale
  maxDate: 'today',
  // Add other options and configurations as needed
  altInput: true, // Enable alternate input
  altFormat: 'd F Y', // 'YYYY-MM-DD' format for hidden input
  onChange: function (selectedDates, dateStr, instance) {
    // Set minDate of end date picker based on selected start date
    StartDate.set('maxDate', dateStr);
  },
});

function loadDataGrafikTimeTravel(periode) {
  $.ajax({
    url: `/StationDetail/GetDataGrafikTimeTravel?periode=${periode}`,
    type: 'GET',
    dataType: 'json',
    async: true,
    success: function (data) {
      if (data != null) {
        generateGrafikTimeTravel(data, periode);
      }
    },
    error: function (xhr, status, error) {
      console.error('Error: ' + status + ' - ' + error);
    },
  });
}

function loadDataPeriodeGrafikTimeTravel(startDate, endDate) {
  $.ajax({
    url: `/StationDetail/GetDataPeriodeGrafikTimeTravel`,
    type: 'GET',
    async: true,
    data: {
      startDate: startDate,
      endDate: endDate,
    },
    beforeSend: function () {
      const chartEta = document.getElementById('container-eta');
      if (typeof Highcharts !== 'undefined' && chartEta && CHART_ETA) {
        CHART_ETA.destroy();
        CHART_ETA = null;
      }
      const label = `<div class="text-center">
                                                    <h5 class="text-secondary" id="not-exist3">Loading ...</h5>
                                                </div>`;
      if (!document.getElementById('not-exist3')) {
        $('#container-eta').append(label);
      }
    },
    success: function (data) {
      $('#not-exist3').remove();
      if (data == null || data.length == 0) {
        const chartEta = document.getElementById('container-eta');
        if (typeof Highcharts !== 'undefined' && chartEta && CHART_ETA) {
          CHART_ETA.destroy();
          CHART_ETA = null;
        }
        const label = `<div class="text-center">
                                                    <h5 class="text-secondary" id="not-exist3">Data Grafik Tidak Tersedia</h5>
                                                </div>`;
        if (!document.getElementById('not-exist3')) {
          $('#container-eta').append(label);
        }
      } else {
        generatePeriodeGrafikTimeTravel(data, startDate, endDate);
      }
    },
    error: function (xhr, status, error) {
      console.error('Error: ' + status + ' - ' + error);
    },
  });
}

function downloadData() {
  const stratDate = $('#filter-periode-start').val();
  const endDate = $('#filter-periode-end').val();
  var url = `/StationDetail/ExportData?startDate=${stratDate}&endDate=${endDate}`;
  window.open(url, '_blank');
}

function generateGrafikTimeTravel(data, periode) {
  var dataSeries = data.map((item) => {
    return {
      name: item.stationName,
      data: item.data.map((point) => [point.millis, point.debit]),
    };
  });

  let formattedDate = '';

  let splitPeriode = periode.split('-');
  if (splitPeriode.length == 2) {
    let date = moment(new Date(), 'YYYY-MM');
    formattedDate = date.locale('id').format('MMMM YYYY');
  } else {
    let date = moment(new Date(), 'YYYY-MM');
    formattedDate = date.locale('id').format('MMMM YYYY');
  }

  // Highcharts.setOptions(Highcharts.theme);
  Highcharts.stockChart('container-eta-mini', {
    chart: {
      backgroundColor: '#2F3567', // Set to your desired dark color
      // other chart options...
    },
    title: {
      text: `Grafik Prediksi Time Travel Air`,

      style: {
        color: '#A1A3BA', // Set font color to white
      },
    },
    subtitle: {
      text: `<p>Per ${formattedDate} </p>`,
      style: {
        color: '#A1A3BA', // Set font color to white
      },
    },
    rangeSelector: {
      enabled: false,
    },

    legend: {
      enabled: true, // Display the legend,
      itemStyle: {
        color: '#A1A3BA', // Set font color to white
      },
    },

    yAxis: {
      title: {
        text: 'Prediksi Debit (m3/s)',
      },
      labels: {
        style: {
          color: '#A1A3BA', // Set y-axis label font color to white
        },
      },
      min: 0,
      plotLines: [
        {
          value: 0,
          width: 2,
          color: 'silver',
        },
      ],
    },

    plotOptions: {
      series: {
        compare: 'percent',
        showInNavigator: true,
      },
    },

    tooltip: {
      useHTML: true,
      shared: true,
      split: false,
      backgroundColor: '#ffffff',
      borderColor: '#e6e6e6',
      borderRadius: 10,
      shadow: true,
      formatter: function () {
        let s = '';
        this.points.forEach(function (point, index) {
          // Menambahkan pembungkus div dengan margin-bottom agar ada jarak antar stasiun
          // Menambahkan border-top tipis kecuali untuk item pertama agar lebih rapi
          let borderStyle =
            index > 0
              ? 'border-top: 1px solid #eee; padding-top: 5px; margin-top: 5px;'
              : '';

          s += `<div style="${borderStyle} margin-bottom: 8px;">`;

          // Header Station Name - Ukuran font dikecilkan ke 11px atau 12px
          s += `<span style="font-size: 11px; color: #48ADF1; font-weight: bold; text-transform: uppercase; display: block; margin-bottom: 2px;">${point.series.name}</span>`;

          // Baris Debit
          s += `<span style="font-size: 11px; color: #333;">Debit Prediksi : </span>`;
          s += `<span style="font-size: 11px; font-weight: bold; color: #000;">${point.y.toFixed(2)} m3/s</span><br/>`;

          // Baris Waktu
          s += `<span style="font-size: 11px; color: #333;">Waktu Prediksi: </span>`;
          s += `<span style="font-size: 11px; font-weight: bold; color: #000;">${Highcharts.dateFormat('%d %B %Y %H:%M', point.x)} WIB</span>`;

          s += `</div>`;
        });
        return s;
      },
    },
    series: dataSeries,
  });
}

function generatePeriodeGrafikTimeTravel(data, startDate, endDate) {
  var dataSeries = data.map((item) => {
    return {
      name: item.stationName,
      data: item.data.map((point) => [point.millis, point.debit]),
    };
  });

  // Highcharts.setOptions(Highcharts.theme);
  CHART_ETA = Highcharts.stockChart('container-eta', {
    chart: {
      //backgroundColor: '#2F3567',  // Set to your desired dark color
      // other chart options...
    },
    title: {
      text: `Grafik Prediksi Time Travel Air`,

      style: {
        color: '#A1A3BA', // Set font color to white
      },
    },
    subtitle: {},
    rangeSelector: {
      enabled: false,
    },

    legend: {
      enabled: true, // Display the legend,
      itemStyle: {
        color: '#A1A3BA', // Set font color to white
      },
    },

    yAxis: {
      title: {
        text: 'Prediksi Debit (m3/s)',
      },
      labels: {
        style: {
          color: '#A1A3BA', // Set y-axis label font color to white
        },
      },
      min: 0,
      plotLines: [
        {
          value: 0,
          width: 2,
          color: 'silver',
        },
      ],
    },

    plotOptions: {
      series: {
        compare: 'percent',
        showInNavigator: true,
      },
    },

    tooltip: {
      pointFormat:
        '<span style="color:{series.color}"><b>{series.name}</b></span> <br/>Debit Prediksi    : <b>{point.y:.2f} m3/s</b><br/>Waktu Prediksi: <b>{point.x:%d %B %Y %H:%M} WIB</b><br/>',
      split: true,
    },
    series: dataSeries,
  });
}

let latestFileGenangan = '';

var currentTime = new Date();
var maxDifference = 10 * 60 * 1000; // 10 menit dalam milidetik

function loadGrafik12Jam(id, type) {
  if (type == 'awlr') loadGrafikAwlr(id); // Hapus template literal yang tidak perlu
  if (type == 'arr') loadGrafikArr(id);
}

function loadGrafikAwlr(station_id) {
  const lightGrey = '#E0E0E0';
  const startTime = performance.now();

  const chartContainer = document.getElementById('grafik-12-jam-terakhir');
  if (!chartContainer) return;

  chartContainer.innerHTML = `
        <div style="text-align:center;padding:20px;color:#E0E0E0;">
            <div class="spinner-border text-primary" role="status"></div>
            <p style="margin-top:10px;">Memuat data...</p>
            <small id="fetch-timer" style="color:#999;">0s</small>
        </div>`;

  const timerInterval = setInterval(() => {
    const elapsed = Math.round((performance.now() - startTime) / 1000);
    const timerEl = document.getElementById('fetch-timer');
    if (timerEl) timerEl.textContent = `${elapsed}s`;
  }, 1000);

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 30000);

  fetch(`/Home/GetGrafikAwlr12Jam?station_id=${station_id}`, {
    signal: controller.signal,
    headers: { Accept: 'application/json' },
  })
    .then((response) => {
      clearTimeout(timeoutId);
      clearInterval(timerInterval);
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      return response.json();
    })
    .then((res) => {
      if (!res.data || !Array.isArray(res.data)) res.data = [];

      const dataAWLR = res.data;
      const seriesData = [];

      // 1. Tambahkan Series Utama (TMA)
      seriesData.push({
        name: 'TMA',
        type: 'areaspline',
        data: dataAWLR,
        color: '#7cb5ec',
        fillOpacity: 0.3,
        threshold: null,
        softThreshold: false,
        zIndex: 10, // Agar garis TMA berada paling depan
        tooltip: { valueSuffix: ` ${res.unit_display || 'm'}` },
        marker: { enabled: false },
      });

      // 2. Logika Penambahan Garis Siaga (Plot Lines as Series)
      // ... di dalam fetch .then(res => { ...

      if (dataAWLR.length > 0) {
        const minX = dataAWLR[0][0];
        const maxX = dataAWLR[dataAWLR.length - 1][0];

        const createSiagaSeries = (name, value, color) => {
          if (value && value > 0) {
            return {
              name: name,
              type: 'line',
              data: [
                [minX, value],
                [maxX, value],
              ],
              color: color,
              dashStyle: 'ShortDash',
              lineWidth: 2,
              marker: { enabled: false },
              enableMouseTracking: true,
              zIndex: 5,
              // --- INI KUNCINYA ---
              visible: false, // Series ada di legend tapi default-nya tersembunyi
            };
          }
          return null;
        };

        const s1 = createSiagaSeries('Siaga 1', res.siaga1, '#ff4d4d');
        const s2 = createSiagaSeries('Siaga 2', res.siaga2, '#ffa500');
        const s3 = createSiagaSeries('Siaga 3', res.siaga3, '#ffff00');

        if (s1) seriesData.push(s1);
        if (s2) seriesData.push(s2);
        if (s3) seriesData.push(s3);
      }

      // ... lanjut ke Highcharts.chart ...

      // 3. Render Chart
      Highcharts.chart('grafik-12-jam-terakhir', {
        chart: {
          zoomType: 'x',
          backgroundColor: 'transparent',
          marginBottom: 90,
        },
        title: {
          text: res.station_name || '',
          style: { color: lightGrey, fontSize: '14px' },
        },
        xAxis: {
          type: 'datetime',
          labels: {
            style: { color: lightGrey, fontSize: '9px' },
            format: '{value:%d %b %Y %H:%M}',
            rotation: -45,
            align: 'right',
          },
          lineColor: lightGrey,
        },
        yAxis: {
          title: {
            text: `TMA (${res.unit_display || 'm'})`,
            style: { color: lightGrey },
          },
          labels: { style: { color: lightGrey } },
          gridLineColor: 'rgba(255, 255, 255, 0.1)',
          startOnTick: false,
          endOnTick: false,
        },
        legend: {
          enabled: true,
          itemStyle: { color: lightGrey, fontSize: '10px' },
          verticalAlign: 'bottom',
          y: 15,
        },
        tooltip: {
          shared: true,
          xDateFormat: '%d %b %Y %H:%M',
        },
        series: seriesData, // Menggunakan array series yang sudah kita build
        credits: { enabled: false },
      });
    })
    .catch((error) => {
      clearInterval(timerInterval);
      chartContainer.innerHTML = `
            <div style="text-align:center;padding:20px;color:#ff6b6b;">
                <p>${error.message}</p>
                <button onclick="loadGrafikAwlr('${station_id}')" class="btn btn-sm btn-outline-primary">Coba Lagi</button>
            </div>`;
    });
}

function loadGrafikArr(station_id) {
  const lightGrey = '#E0E0E0';
  const startTime = performance.now();

  // 1. Validasi Container
  const chartContainer = document.getElementById('grafik-12-jam-terakhir');
  if (!chartContainer) {
    console.error('❌ Container #grafik-12-jam-terakhir tidak ditemukan');
    return;
  }

  // 2. Tampilkan Loading State
  chartContainer.innerHTML = `
        <div style="text-align:center;padding:20px;color:#E0E0E0;">
            <div class="spinner-border text-info" role="status"></div>
            <p style="margin-top:10px;">Memuat data Curah Hujan...</p>
            <small id="fetch-timer-arr" style="color:#999;">0s</small>
        </div>
    `;

  const timerInterval = setInterval(() => {
    const elapsed = Math.round((performance.now() - startTime) / 1000);
    const timerEl = document.getElementById('fetch-timer-arr');
    if (timerEl) {
      timerEl.textContent = `${elapsed}s`;
      if (elapsed > 5) timerEl.style.color = '#ff9800';
      if (elapsed > 10) timerEl.style.color = '#f44336';
    }
  }, 1000);

  // 3. Persiapan Fetch
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 30000);

  // Endpoint disesuaikan (Asumsi: GetGrafikArr12Jam)
  const url = `/Home/GetGrafikArr12Jam?station_id=${station_id}`;

  fetch(url, {
    signal: controller.signal,
    headers: { Accept: 'application/json' },
  })
    .then((response) => {
      clearTimeout(timeoutId);
      clearInterval(timerInterval);
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      return response.json();
    })
    .then((res) => {
      if (!res || !res.data) throw new Error('Data tidak ditemukan');

      const dataARR = res.data; // Format: [[timestamp, value], ...]

      // 4. Destroy chart lama jika ada
      const existingChart = Highcharts.charts.find(
        (chart) =>
          chart &&
          chart.renderTo &&
          chart.renderTo.id === 'grafik-12-jam-terakhir',
      );
      if (existingChart) existingChart.destroy();

      // 5. Render Highcharts (Tipe Column untuk Curah Hujan)
      Highcharts.chart('grafik-12-jam-terakhir', {
        chart: {
          zoomType: 'x',
          backgroundColor: 'transparent',
          marginBottom: 125, // Ruang untuk label x-axis yang miring
          spacingBottom: 25,
        },
        title: {
          text: `${res.station_name || 'Data Curah Hujan'}`,
          style: { color: lightGrey, fontSize: '14px' },
        },
        xAxis: {
          type: 'datetime',
          labels: {
            style: {
              color: lightGrey,
              fontSize: '9px', // Perkecil font agar lebih rapi
            },
            format: '{value:%d %b %Y %H:%M}',
            rotation: -45,
            align: 'right',
            y: 15, // Jarak teks label dari garis axis
          },
        },
        yAxis: {
          title: {
            text: 'Curah Hujan (mm)',
            style: { color: lightGrey },
          },
          labels: {
            format: '{value} mm',
            style: { color: lightGrey },
          },
          gridLineColor: 'rgba(255, 255, 255, 0.1)',
          min: 0, // Curah hujan tidak mungkin negatif
        },
        tooltip: {
          shared: true,
          xDateFormat: '%d %b %Y %H:%M',
          pointFormat:
            '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y} mm</b><br/>',
        },
        legend: {
          enabled: true,
          itemStyle: { color: lightGrey, fontSize: '10px' },
          verticalAlign: 'bottom',
          layout: 'horizontal',
          // 3. Atur 'y' positif untuk menurunkan legend menjauh dari x-axis
          // Nilai 30-40 biasanya cukup untuk menghindari tabrakan teks miring
          y: 50,
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              style: {
                fontSize: '9px',
                color: lightGrey,
                textOutline: 'none',
              },
              formatter: function () {
                // Tampilkan '0' jika nol, atau nilai + ' mm' jika bukan nol
                return this.y === 0 ? '0' : this.y + ' mm';
              },
            },
          },
        },
        series: [
          {
            name: 'Curah Hujan',
            data: dataARR,
            type: 'column',
            color: '#7cb5ec',
            fillOpacity: 0.3,
            marker: {
              enabled: true, // Diaktifkan agar dataLabels punya titik acuan yang jelas
              radius: 3,
            },
          },
        ],
        credits: { enabled: false },
      });
    })
    .catch((error) => {
      clearTimeout(timeoutId);
      clearInterval(timerInterval);

      const errorTime = Math.round(performance.now() - startTime);
      let errorMessage =
        error.name === 'AbortError' ? 'Request Timeout' : error.message;

      chartContainer.innerHTML = `
            <div style="text-align:center;padding:20px;color:#ff6b6b;">
                <i class="mdi mdi-alert-circle" style="font-size:48px;"></i>
                <p style="margin:10px 0;font-weight:600;">${errorMessage}</p>
                <button onclick="loadGrafikArr('${station_id}')" 
                        class="btn btn-sm btn-outline-info mt-2"
                        style="border:1px solid #2ecc71; color:#2ecc71; background:none; padding:8px 16px; border-radius:4px; cursor:pointer;">
                    🔄 Coba Lagi
                </button>
            </div>
        `;
    });
}

// Fungsi helper untuk unbind event sebelum bind ulang
function attachAwlrClickHandler(stationId, latitude, longitude) {
  const selector = `.card-station-awlr[data-ts-id="${stationId}"]`;

  // Unbind event lama
  $(selector).off('click');

  // Bind event baru
  $(selector).on('click', function () {
    map.setView([latitude, longitude], 12);

    // Pastikan marker ada
    const marker = awlr_marker
      .getLayers()
      .find((layer) => layer.options && layer.options.id === stationId);

    if (marker) {
      marker.openPopup();
    } else {
      console.warn(`⚠️ Marker not found for station: ${stationId}`);
    }

    loadGrafik12Jam(stationId, 'awlr');
    //testFetch(stationId);
  });
}

const app_name = $('#app-name').val();
const awlr_marker = L.layerGroup();
const arr_marker = L.layerGroup();
const wq_marker = L.layerGroup();

const map = L.map('map', {
  center: [-6.3727759, 106.8198829],
  zoom: 10,
  // layers: [awlr_marker, arr_marker, wq_marker]
});

map.attributionControl.setPrefix(false);

arr_marker.addTo(map);

const legend = L.control({ position: 'bottomright' });

legend.onAdd = function (map) {
  var div = L.DomUtil.create('div', 'info legend small-legend');
  div.id = 'legend-genangan';
  div.innerHTML += '<h5>Kedalaman Genangan</h5>';
  div.innerHTML += '<i style="background: blue"></i><span>< 0,5 m</span><br>';
  div.innerHTML +=
    '<i style="background: yellow"></i><span>0,5 - 1,0 m</span><br>';
  div.innerHTML +=
    '<i style="background: orange"></i><span>1,0 - 1,5 m</span><br>';
  div.innerHTML +=
    '<i style="background: red"></i><span>1,5 - 2,0 m</span><br>';
  div.innerHTML +=
    '<i style="background: #C500FE"></i><span>> 2,0 m</span><br>';

  return div;
};

legend.addTo(map); //hilangkan legend Kedalaman Genanagan

/* Custom Legend Arr */
//var customLegendArr = L.control({ position: 'bottomleft' });
//var customLegendAwlr = L.control({ position: 'bottomleft' });
//var customLegendWq = L.control({ position: 'bottomleft' });

//var infoLegendArr_old = [
//    { label: 'Tidak Hujan (0mm/jam)', color: '#FFFFFF' },
//    { label: 'Sangat Ringan (0-1mm/jam)', color: '#CDEBCA' },
//    { label: 'Ringan (1-5 mm/jam)', color: '#449C44' },
//    { label: 'Sedang (5-10 mm/jam)', color: '#FFFF00' },
//    { label: 'Lebat (10-20 mm/jam)', color: '#F28528' },
//    { label: 'Sangat Lebat (>20 mm/jam)', color: '#E40000' },
//    { label: 'Extream (>100 mm/jam)', color: '#FF00FF' }
//];

//var infoLegendArr = [
//    { label: 'Pos Offlie', image: '/images/arr/arr-icon-offline.png' },
//    { label: 'Tidak Hujan (0mm/jam)', image: '/images/arr/berawan.png' },
//    { label: 'Hujan Ringan (1-5 mm/jam)', image: '/images/arr/hujan-ringan.png' },
//    { label: 'Hujan Sedang (5-10 mm/jam)', image: '/images/arr/hujan-sedang.png' },
//    { label: 'Hujan Lebat (10-20 mm/jam)', image: '/images/arr/hujan-lebat.png' },
//    { label: 'Hujan Sangat Lebat (>20 mm/jam)', image: '/images/arr/hujan-sangat-lebat.png' },
//];

//var infoLegendAwlr = [
//  { label: "Normal", color: "#0029FE", path: "/images/awlr/siaga_4.png" },
//  { label: "Waspada", color: "#09FE02", path: "/images/awlr/siaga_3.png" },
//  { label: "Siaga", color: "#FDFE01", path: "/images/awlr/siaga_2.png" },
//  { label: "Awas", color: "#F40A07", path: "/images/awlr/siaga_1.png" },
//];

//var infoLegendWq = [
//    { label: 'Normal', color: '#000000', path: '/images/water-quality/wq-normal.svg' },
//    { label: 'Cemar Ringan', color: '#FFFF00', path: '/images/water-quality/wq-cemar-ringan.svg' },
//    { label: 'Cemar Sedang', color: '#FFA500', path: '/images/water-quality/wq-cemar-sedang.svg' },
//    { label: 'Cemar Berat', color: '#FF0000', path: '/images/water-quality/wq-cemar-berat.svg' }
//];

//customLegendArr.onAdd = function (map) {
//    let div = L.DomUtil.create('div', 'info legend small-legend');
//    div.id = 'legend-curah-hujan';
//    // Menambahkan sedikit padding dan background pada kontainer legenda utama
//    div.style.padding = '10px';
//    div.style.backgroundColor = 'rgba(255, 255, 255, 0.75)';
//    div.style.borderRadius = '5px';
//    div.style.boxShadow = '0 0 15px rgba(0,0,0,0.2)';

//    div.innerHTML = '<h4 style="margin: 0 0 10px;">Klasifikasi Curah Hujan <small class="text-muted">(mm/jam)</small> :</h4>';

//    for (var i = 0; i < infoLegendArr.length; i++) {
//        // Menambahkan elemen dengan inline style
//        div.innerHTML += `
//                    <div style="display: flex; align-items: center; margin-bottom: 5px;">
//                        <img src="${infoLegendArr[i].image}"
//                            alt="${infoLegendArr[i].label}"
//                            style="width: 18px; height: 18px; margin-right: 8px; object-fit: contain;">
//                        <span>${infoLegendArr[i].label}</span>
//                    </div>
//                `;
//    }

//    return div;
//};

//// Create a custom legend control for AWLR, similar to customLegendWq
//customLegendAwlr.onAdd = function (map) {
//    // Create a new div element for the legend
//    let div = L.DomUtil.create('div', 'info legend small-legend');
//    div.id = 'legend-awlr';
//    div.style.backgroundColor = 'rgba(255, 255, 255, 0.75)';

//    // Add a title to the legend
//    div.innerHTML = '<h4>Status Siaga :</h4>';

//    // Loop through the legend data to add items to the div
//    for (var i = 0; i < infoLegendAwlr.length; i++) {
//        // Create an item with a PNG icon and a label.
//        // Use flexbox to vertically center the image and the text.
//        div.innerHTML +=
//          '<div style="display: flex; align-items: center; margin-bottom: 5px;">' +
//          '<img src="' +
//          infoLegendAwlr[i].path +
//          '" alt="' +
//          infoLegendAwlr[i].label +
//          '" style="width:25px; height:25px; margin-right: 5px;">' +
//          "<span>" +
//          getLabelLegendAwlr(infoLegendAwlr[i].label) +
//          "</span>" +
//          "</div>";
//    }

//    // Return the created div
//    return div;
//};

//function getLabelLegendAwlr(label){
//  if(label == null || label == ''){
//    return '';
//  }
//  switch (label.toLowerCase()) {
//    case "normal":
//      return "Normal (Siaga IV)";
//    case "siaga":
//      return "Siaga (Siaga II)";
//    case "waspada":
//      return "Waspada (Siaga III)";
//    case "awas":
//      return "Awas (Siaga I)";
//    default:
//      return '';
//  }
//}

//customLegendWq.onAdd = function (map) {
//    // Create a new div element for the legend
//    let div = L.DomUtil.create('div', 'info legend small-legend');
//    div.id = 'legend-water-quality';
//    div.style.backgroundColor = 'rgba(255, 255, 255, 0.75)';

//    // Add a title to the legend
//    div.innerHTML = '<h4>Index Kualitas Air :</h4>';

//    // Loop through the legend data to add items to the div
//    for (var i = 0; i < infoLegendWq.length; i++) {
//        div.innerHTML +=
//            '<div style="display: flex; align-items: center; margin-bottom: 5px;">' +
//            '<img src="' + infoLegendWq[i].path + '" alt="' + infoLegendWq[i].label + '" style="width:25px; height:25px; margin-right: 5px;">' +
//            '<span>' + infoLegendWq[i].label + '</span>' +
//            '</div>';
//    }

//    // Return the created div
//    return div;
//};

//customLegendArr.addTo(map);
//customLegendAwlr.addTo(map);
//customLegendWq.addTo(map);

new L.basemapsSwitcher(
  [
    {
      layer: L.mapboxGL({
        accessToken:
          'pk.eyJ1IjoiaGFuZHlhc3dhbiIsImEiOiJjbDY3YmNmcGgwODAxM2R0YjZzY3ZkN3M5In0.7aDstmvWZvOmZIwyPfMB4g',
        style: 'mapbox://styles/mapbox/streets-v11',
        attribution: `&copy;20240325 ${app_name} Version 4.0.0 | Model Genangan Versi 6.0`,
      }).addTo(map), //DEFAULT MAP
      icon: '/images/basemaps/basemap-grayscale.jpg',
      name: 'Grayscale',
    },
    {
      layer: L.mapboxGL({
        accessToken:
          'pk.eyJ1IjoiaGFuZHlhc3dhbiIsImEiOiJjbDY3YmNmcGgwODAxM2R0YjZzY3ZkN3M5In0.7aDstmvWZvOmZIwyPfMB4g',
        style: 'mapbox://styles/mapbox/satellite-streets-v12',
        attribution: `${app_name} &copy;${new Date().getFullYear()}`,
      }),
      icon: '/images/basemaps/basemap-satellite.jpg',
      name: 'Satellite',
    },
    {
      layer: L.tileLayer(
        'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        {
          attribution: `${app_name} &copy;${new Date().getFullYear()}`,
        },
      ),
      icon: '/images/basemaps/world-imagery.jpg',
      name: 'W.Imagery',
    },
  ],
  { position: 'topright' },
).addTo(map);

const overlays = {
  'Pos Duga Air': awlr_marker,
  'Pos Curah Hujan': arr_marker,
  'Pos Kualitas Air': wq_marker,
};

const layerControl = L.control.layers(null, overlays).addTo(map);

map.whenReady(() => {
  const btn = document.querySelector('.leaflet-control-layers-toggle');
  if (!btn) return;

  btn.style.background =
    "#fff url('https://unpkg.com/leaflet@1.9.4/dist/images/layers.png') center / 26px no-repeat";
  btn.style.width = '36px';
  btn.style.height = '36px';
  btn.style.borderRadius = '4px';
});

function toggleLegend(legendId, show) {
  const legendElement = document.getElementById(legendId);
  if (legendElement) {
    if (show === true) {
      legendElement.style.display = 'block';
    } else if (show === false) {
      legendElement.style.display = 'none';
    } else {
      // Jika argumen show tidak diberikan, kita akan toggle visibilitasnya
      legendElement.style.display =
        legendElement.style.display === 'none' ? 'block' : 'none';
    }
  }
}

$(document).ready(function () {
  // await preloadWqSvg();
  // Remove classes from all elements with class matching the pattern
  $('[class^="alert-siaga"]').removeClass(function (index, className) {
    return (className.match(/\balert-siaga\S+/g) || []).join(' ');
  });

  toggleLegend('legend-curah-hujan', false);
  toggleLegend('legend-water-quality', false);
  toggleLegend('legend-awlr', false);
  toggleLegend('legend-genangan', false);

  //loadGenangan(latestFileGenangan);
  /* Custom Anthony */
  loadDataGrafikTimeTravel('');
  let sendFormatDate = '';
  flatpickr('#filter-date', {
    dateFormat: 'Ymd', // '04 Januari 2023' format
    defaultDate: 'today', // Set default date to today
    locale: 'id', // Indonesian locale
    maxDate: 'today',
    // Add other options and configurations as needed
    altInput: true, // Enable alternate input
    altFormat: 'd F Y', // 'YYYY-MM-DD' format for hidden input
  });

  $('#filter-date').on('change', function () {
    $.ajax({
      url: '/Home/GetListFileGenangan',
      type: 'GET',
      data: {
        filterDate: $(this).val(),
      },
      //async: false, // Set async to false for a synchronous request
      success: function (data) {
        // Handle the successful response
        loadDatatableFileGenangan(data);
      },
      error: function (xhr, status, error) {
        // Handle errors
      },
    });
  });

  $('#tbl-archive-genangan').DataTable({
    processing: true,
    serverSide: false,
    dom: 'tipr',
    language: {
      paginate: {
        previous: "<i class='mdi mdi-chevron-left'>",
        next: "<i class='mdi mdi-chevron-right'>",
      },
    },
    columnDefs: [
      {
        targets: 0,
        searchable: false,
        orderable: false,
        width: '2%',
        className: 'text-center',
      },
    ],
    drawCallback: function () {
      $('.dataTables_paginate > .pagination').addClass('pagination-rounded');
    },
  });

  $('#tbl-sample-genangan').DataTable({
    processing: true,
    serverSide: false,
    dom: 'tipr',
    language: {
      paginate: {
        previous: "<i class='mdi mdi-chevron-left'>",
        next: "<i class='mdi mdi-chevron-right'>",
      },
    },
    columnDefs: [
      {
        targets: 0,
        searchable: false,
        orderable: false,
        width: '2%',
        className: 'text-center',
      },
    ],
    drawCallback: function () {
      $('.dataTables_paginate > .pagination').addClass('pagination-rounded');
    },
  });

  let previousValue = '';

  $('.radio-like-checkbox-sample').click(function (e) {
    $('.radio-like-checkbox-sample[name="' + $(this).attr('name') + '"]')
      .not(this)
      .prop('checked', false);
    if ($(this).val() == previousValue) {
      //e.preventDefault();
      previousValue = '';
      removeSampleGenangan($(this).val());
      toggleLegend('legend-genangan', false);
    } else {
      removeSampleGenangan(previousValue);
      //loadSampleGenangan($(this).val());
      previousValue = $(this).val();
      toggleLegend('legend-genangan', true);
    }
  });

  $('.radio-like-checkbox-archive').click(function (e) {
    $('.radio-like-checkbox-archive[name="' + $(this).attr('name') + '"]')
      .not(this)
      .prop('checked', false);
    if ($(this).val() == previousValue) {
      //e.preventDefault();
      previousValue = '';
      removeSampleGenangan($(this).val());
      toggleLegend('legend-genangan', false);
    } else {
      removeSampleGenangan(previousValue);
      //loadSampleGenangan($(this).val());
      previousValue = $(this).val();
      toggleLegend('legend-genangan', true);
    }
  });

  function loadDatatableFileGenangan(datas) {
    $('#tbl-data-genangan').DataTable().destroy();
    $('#tbl-data-genangan').DataTable({
      processing: true,
      serverSide: false,
      pageLength: 5,
      dom: 'tipr',
      data: datas,
      language: {
        paginate: {
          previous: "<i class='mdi mdi-chevron-left'>",
          next: "<i class='mdi mdi-chevron-right'>",
        },
      },
      columns: [
        { data: 'file_name', name: 'file_name' },
        {
          data: 'date',
          name: 'date',
          render: function (data) {
            return moment(data).locale('id').format('DD MMMM YYYY HH:mm');
          },
        },
        { data: null },
      ],
      columnDefs: [
        {
          targets: 2,
          searchable: false,
          orderable: false,
          width: '2%',
          className: 'text-end',
          render: function (data, type, row) {
            return `<button data-file="${row.file_name}" data-date="${row.date}" class="btn btn-primary btn-sm" onclick="showGenangan(this,event)">Pilih</button>`;
          },
        },
      ],
      drawCallback: function () {
        $('.dataTables_paginate > .pagination').addClass('pagination-rounded');
      },
    });
  }
  //click munculkan dialog date picker
  $('#input-genangan').on('click', function () {
    $('#tbl-data-genangan').DataTable().destroy();
    let datas = [];
    $.ajax({
      url: '/Home/GetListFileGenangan',
      type: 'GET',

      success: function (data) {
        loadDatatableFileGenangan(data);
      },
      error: function (error) {
        console.error('Error:', error);
      },
    });
  });

  /* End Custom Anthony */

  // Panggil fungsi updateClock setiap detik (1000 milidetik)
  //setInterval(updateClock, 1000);

  // Panggil fungsi updateClock saat halaman dimuat pertama kali
  updateClock();
  loadArrLastReading2();
  loadAwlrLastReading2();
  //loadOfflinePos();

  loadContentWaterQuality();
  //loadCctv();
  loadCctvDummy();
  // Retrieve the last selected tab from local storage

  loadGrafik12Jam('d46da153-06f1-4b3d-baf7-5241d3b7b416', 'awlr');

  const lastTab = localStorage.getItem('tab-center-left');

  if (lastTab) {
    // Activate the last selected tab
    $(`#tab-center-left a[href="#${lastTab}"]`).tab('show');
    if (lastTab == 'tab-arr') {
      toggleLegend('legend-curah-hujan', true);
      toggleLegend('legend-awlr', false);
      toggleLegend('legend-water-quality', false);
    } else if (lastTab == 'tab-awlr') {
      toggleLegend('legend-awlr', true);
      toggleLegend('legend-curah-hujan', false);
      toggleLegend('legend-water-quality', false);
    } else if (lastTab == 'tab-wq') {
      toggleLegend('legend-water-quality', true);
      toggleLegend('legend-awlr', false);
      toggleLegend('legend-curah-hujan', false);
    } else {
      toggleLegend('legend-curah-hujan', false);
      toggleLegend('legend-water-quality', false);
      toggleLegend('legend-awlr', false);
    }
  } else {
    $(`#tab-center-left a[href="#tab-awlr"]`).tab('show');
  }

  // Store the selected tab in local storage when a tab is clicked
  $('#tab-center-left a').on('click', function (e) {
    const selectedTab = $(this).attr('href').replace('#', '');
    localStorage.setItem('tab-center-left', selectedTab);
    if (selectedTab == 'tab-arr') {
      toggleLegend('legend-curah-hujan', true);
      toggleLegend('legend-awlr', false);
      toggleLegend('legend-water-quality', false);
    } else if (selectedTab == 'tab-awlr') {
      toggleLegend('legend-awlr', true);
      toggleLegend('legend-curah-hujan', false);
      toggleLegend('legend-water-quality', false);
    } else if (selectedTab == 'tab-wq') {
      toggleLegend('legend-water-quality', true);
      toggleLegend('legend-awlr', false);
      toggleLegend('legend-curah-hujan', false);
    } else {
      toggleLegend('legend-curah-hujan', false);
      toggleLegend('legend-water-quality', false);
      toggleLegend('legend-awlr', false);
    }
  });

  // Function to generate a consistent color based on a string
  function generateColor(str) {
    // Simple hash function to generate a color based on the input string
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    // Convert the hash to a hex color code
    var color = (hash & 0x00ffffff).toString(16).toUpperCase();
    return '#' + '00000'.substring(0, 6 - color.length) + color;
  }

  // Function to get or generate a color for a specific DAS_NAME
  function getColorForDASName(DAS_NAME) {
    var storedColor = localStorage.getItem('color-' + DAS_NAME);

    if (!storedColor) {
      var generatedColor = generateColor(DAS_NAME);
      // Generate a new color and store it in local storage
      if (DAS_NAME == 'Das Bekasi') {
        generatedColor = '#4EC2DD';
      }

      localStorage.setItem('color-' + DAS_NAME, generatedColor);
      return generatedColor;
    }

    return storedColor;
  }

  let colors = [
    '#e6194b',
    '#3cb44b',
    '#ffe119',
    '#4363d8',
    '#f58231',
    '#911eb4',
    '#46f0f0',
    '#f032e6',
    '#bcf60c',
    '#fabebe',
    '#008080',
    '#e6beff',
    '#9a6324',
    '#fffac8',
    '#800000',
    '#aaffc3',
    '#808000',
    '#ffd8b1',
    '#000075',
  ];

  let i = 0;

  $.getJSON('/data/das_ciliwung_cisadane.json', function (geojson) {
    window.geojsonLayerDAS = L.geoJson(geojson, {
      onEachFeature: function (feature, layer) {
        layer
          .bindTooltip(createDetailPanel(feature.properties), {
            direction: 'right',
            permanent: false,
            sticky: true,
            offset: [10, 0],
            opacity: 0.9,
            className: 'leaflet-tooltip-own',
          })
          .openTooltip();

        layer.setStyle({
          fill: true,
          stroke: true,
          color: '#502909',
          fillColor: colors[i++],
          weight: 1,
          fillOpacity: 0.6,
        });
        if (i > 18) i = 0;

        layer.on('mouseout', function () {
          layer.setStyle({ fillOpacity: 0.6, weight: 1 });
        });
        layer.on('mouseover', function () {
          layer.setStyle({ fillOpacity: 0.8, weight: 1.5 });
        });
      },
    });

    layerControl.addOverlay(geojsonLayer, 'DAS');
  });

  function createDetailPanel(properties) {
    var panelContent = `
                    <h5 style="font-size: 0.75rem;margin: 3px 0;"><span style="color: #0ECAF0;">#${
                      properties.kode_das
                    }: </span> <span style="color: #FFC10A;">${
                      properties.name
                    }</span></h5>
                    <p style="color: #fcfcfc;font-size: 0.65rem;margin: 0;">Luas: ${properties.luas.toLocaleString(
                      'de-DE',
                      { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                    )} (Ha)</p>
                `;

    return panelContent;
  }

  function genanganDetailPanel(properties) {
    // Create a Bootstrap 5 responsive detail panel
    var panelContent = '<div class="container p-0">';
    for (var key in properties) {
      panelContent += '<div class="row">';
      panelContent +=
        '<div class="col-sm-4 text-muted small">' + key + '</div>';
      panelContent +=
        '<div class="col-sm-8 small">' + properties[key] + '</div>';
      panelContent += '</div>';
    }
    panelContent += '</div>';

    return panelContent;
  }

  $.getJSON('/data/sungai_ciliwung_cisadane.json', function (geojson) {
    window.geojsonLayerSungai = L.geoJson(geojson, {
      style: function (feature) {
        return {
          weight: 1.2,
          color: '#3388FF',
          opacity: 0.8,
          // 'fillColor': '#F7CF5F',
          // 'fillOpacity': 0.1
        };
      },
      onEachFeature: function (feature, layer) {
        if (
          feature.properties.NAMA_SUNGA != null &&
          feature.properties.ORDE != '1'
        ) {
          // controlLayers.addOverlay(layer, feature.properties.NAMA_SUNGA);
        }
      },
    }).addTo(map);

    layerControl.addOverlay(geojsonLayer, 'Sungai');
  });

  $('.image-popup-single').magnificPopup({
    type: 'image',
    closeOnContentClick: false,
    closeBtnInside: false,
    mainClass: 'mfp-with-zoom mfp-img-mobile',
    image: {
      verticalFit: true,
      titleSrc: function (item) {
        return item.el.attr('title');
      },
    },
    zoom: {
      enabled: true,
      duration: 300, // don't foget to change the duration also in CSS
      opener: function (element) {
        return element.find('img');
      },
    },
  });

  $('.image-popup').magnificPopup({
    type: 'inline',
    midClick: true, // Allow opening on middle mouse button click.

    // Hooks/Fungsi saat popup dibuka dan ditutup
    callbacks: {
      // Fungsi yang dipanggil setelah popup dibuka
      open: function () {
        // Pastikan video mulai diputar
        $('#popupVideoPlayer')[0].play();
      },
      // Fungsi yang dipanggil saat popup ditutup
      close: function () {
        // Menghentikan video saat popup ditutup untuk menghemat bandwidth
        $('#popupVideoPlayer')[0].pause();
        $('#popupVideoPlayer')[0].currentTime = 0; // Opsional: reset ke awal
      },
    },
  });
});

/*  Custom Anthony -- Fungsi Load Sample Data Genangan */
function loadSampleGenangan(fileName) {
  const path = `/data/sample_genangan/${fileName}`;
  //const path = `/data/sample_genangan/3d02fb7c-c27a-4792-907f-8802852455f3.json`;

  //$.getJSON(path, function (geojson) {
  //  var geojsonLayer = L.geoJson(geojson, {
  //    style: function (feature) {
  //      var kelas = feature.properties.Kelas;
  //      if (kelas == 1) {
  //        return {
  //          weight: 1.5,
  //          color: "blue",
  //          fillColor: "blue",
  //          fillOpacity: 1,
  //        };
  //      } else if (kelas == 2) {
  //        return {
  //          weight: 1.5,
  //          color: "yellow",
  //          fillColor: "yellow",
  //          fillOpacity: 1,
  //        };
  //      } else if (kelas == 3) {
  //        return {
  //          weight: 1.5,
  //          color: "orange",
  //          fillColor: "orange",
  //          fillOpacity: 1,
  //        };
  //      } else if (kelas == 4) {
  //        return {
  //          weight: 1.5,
  //          color: "red",
  //          fillColor: "red",
  //          fillOpacity: 1,
  //        };
  //      } else if (kelas == 5) {
  //        return {
  //          weight: 1.5,
  //          color: "#C500FE",
  //          fillColor: "#C500FE",
  //          fillOpacity: 1,
  //        };
  //      } else {
  //        return {
  //          weight: 1.5,
  //          color: "#1E474E",
  //          fillColor: "#1E474E",
  //          fillOpacity: 1,
  //        };
  //      }
  //    },
  //    onEachFeature: function (feature, layer) {
  //      const kedalaman1 = feature.properties.Kendalaman;
  //      const kedalaman2 = feature.properties.Kedalaman;
  //      const kedalaman = kedalaman1 == undefined ? kedalaman2 : kedalaman1;
  //      if (feature.properties.Kelas != null) {
  //        layer.bindPopup("Kedalaman Air : " + `<strong>${kedalaman}</strong>`);
  //      }
  //    },
  //  }).addTo(map);

  //  layerControl.addOverlay(geojsonLayer, fileName);
  //});
}

function loadGenangan(fileName) {
  const path = `/data/genangan/${fileName}`;
  //const path = `/data/genangan/output3.json`;

  $.getJSON(path, function (geojson) {
    var geojsonLayer = L.geoJson(geojson, {
      style: function (feature) {
        var kelas = feature.properties.Kelas;
        if (kelas == 1) {
          return {
            weight: 1.5,
            color: 'blue',
            fillColor: 'blue',
            fillOpacity: 1,
          };
        } else if (kelas == 2) {
          return {
            weight: 1.5,
            color: 'yellow',
            fillColor: 'yellow',
            fillOpacity: 1,
          };
        } else if (kelas == 3) {
          return {
            weight: 1.5,
            color: 'orange',
            fillColor: 'orange',
            fillOpacity: 1,
          };
        } else if (kelas == 4) {
          return {
            weight: 1.5,
            color: 'red',
            fillColor: 'red',
            fillOpacity: 1,
          };
        } else if (kelas == 5) {
          return {
            weight: 1.5,
            color: '#C500FE',
            fillColor: '#C500FE',
            fillOpacity: 1,
          };
        } else {
          return {
            weight: 1.5,
            color: '#1E474E',
            fillColor: '#1E474E',
            fillOpacity: 1,
          };
        }
      },
      onEachFeature: function (feature, layer) {
        const kedalaman1 = feature.properties.Kendalaman;
        const kedalaman2 = feature.properties.Kedalaman;
        const kedalaman = kedalaman1 == undefined ? kedalaman2 : kedalaman1;
        if (feature.properties.Kelas != null) {
          layer.bindPopup('Kedalaman Air : ' + `<strong>${kedalaman}</strong>`);
        }
      },
    }).addTo(map);

    layerControl.addOverlay(geojsonLayer, fileName);
  });
}

function removeSampleGenangan(layerName) {
  if (layerName == null) {
    return;
  }

  Object.keys(layerControl._layers).forEach(function (id) {
    var overlay = layerControl._layers[id];

    if (
      overlay.name === layerName ||
      overlay.name === 'Genangan' ||
      overlay.name === localStorage.getItem('lastLayer') ||
      overlay.name == latestFileGenangan
    ) {
      layerControl.removeLayer(overlay.layer);
      map.removeLayer(overlay.layer);
    }
  });
}

function showGenangan(input, event) {
  $('.list-time-travel').remove();
  $('#info-genangan span').remove();
  const file_name = $(input).data('file');
  const file_date = $(input).data('date').split('T')[0];
  const display_tgl = moment($(input).data('date'))
    .locale('id')
    .format('D MMMM YYYY');
  const display_jam = moment($(input).data('date'))
    .locale('id')
    .format('HH:mm');
  $('#jam_genangan').text(display_jam);
  $('#tgl_genangan').text(display_tgl);
  let isFileExist = true;
  const parameter_date = moment($(input).data('date'))
    .locale('id')
    .format('YYYY-MM-DD HH:mm:00');
  $.ajax({
    url: '/Home/FileExists',
    type: 'HEAD', // Use HEAD request to check file existence without downloading the file
    data: {
      filename: file_name,
    },
    async: false,
    success: function () {
      isFileExist = true;
    },
    error: function () {
      isFileExist = false;
    },
  });

  if (isFileExist) {
    if (localStorage.getItem('lastLayer') == file_name.replace('.json', '')) {
      localStorage.clear();
    }
    removeSampleGenangan(localStorage.getItem('lastLayer'));
    //loadGenangan(file_name);
    localStorage.setItem('lastLayer', file_name.replace('.json', ''));

    generateTimeTravelByDate(parameter_date);

    $('#modal-genangan').modal('hide');

    if (file_name.split('_').length == 3) {
      $('#info-genangan').append(
        `<span class="small">Peta Genangan ${convertDateString(
          file_name.replace('.json', ''),
        )}</span>`,
      );
    } else {
      $('#info-genangan').append(
        `<span class="small">Peta Genangan ${file_name.replace(
          '.json',
          '',
        )}</span>`,
      );
    }
    $('#info-genangan').fadeIn(250);
  } else {
    generateTimeTravelByDate('');
    $('#info-genangan').fadeOut(250);
    Swal.fire({
      title: 'Maaf!',
      text: 'File tidak ditemukan atau belum tersedia',
      icon: 'error',
      confirmButtonText: 'Kembali',
    });
  }
}

function convertDateToFormatId(date) {
  return moment(date).locale('id').format('DD MMMM YYYY HH:mm');
}

function convertTimeToFormatId(date) {
  return moment(date).locale('id').format('HH:mm');
}

function generateTimeTravelByDate(date) {
  $.ajax({
    url: '/Home/GetListTiveTravelDataByDate',
    type: 'GET', // Use HEAD request to check file existence without downloading the file
    data: {
      date: date,
    },
    success: function (data) {
      data.forEach((e) => {
        let formatDate = '';
        let formatDebit = '';

        if (e.prediction_debit == null) {
          formatDate = `
                                    <span class="small text-center reading-text" style="color:#9395AD">Data Prediksi Time Travel Air Belum Tersedia</span>
                                `;
        } else {
          formatDate = `<span>${convertDateToFormatId(e.prediction_at)}</span>`;
        }

        if (e.prediction_debit == null) {
          formatDebit = `<h4> - </h4>`;
        } else {
          formatDebit = `<h4>${e.prediction_debit}<sup>m<sup>3</sup>/s</sup></h4>`;
        }

        let newList = `
                                    <li class="completed pb-3 list-time-travel" id="">
                                    <h4 class="mt-0 mb-2">${e.station_name}</h4>
                                    <div class="d-flex justify-content-around align-items-center">
                                        <div class="text-center mb-2 mt-1 col-12">
                                            <div class="mb-2" style="color:#D0D1D8">
                                                <i class="fe-calendar me-1"></i>
                                                ${formatDate}
                                            </div>
                                            <div class="d-flex justify-content-around align-items-center reading-text">
                                                <div class="col-4 text-center">
                                                    <h4 class="text-status-normal"> - </h4>
                                                </div>
                                                <div class="col-4 text-center">
                                                    <h4> - </h4>
                                                </div>
                                                <div class="col-4 text-center">
                                                    ${formatDebit}
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-around reading-text" style="color:#9395AD">
                                                <div class="col-4 text-center">
                                                    Tinggi Muka Air
                                                </div>
                                                <div class="col-4 text-center">
                                                    Status TMA
                                                </div>
                                                <div class="col-4 text-center">
                                                    Debit
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            </li>
                            `;

        $('#list-time-travel').append(newList);
      });
    },
    error: function () {
      console.log('Error when call list time travle');
    },
  });
}

function convertDateString(inputString) {
  // Extract date and time components
  const year = inputString.substr(0, 4);
  const month = inputString.substr(4, 2);
  const day = inputString.substr(6, 2);
  const hour = inputString.substr(9, 2);
  const minute = inputString.substr(12, 2);

  // Create a JavaScript Date object
  const dateObject = new Date(`${year}-${month}-${day}T${hour}:${minute}:00`);

  // Format the date and time
  const formattedDate = `${day} ${getMonthName(
    parseInt(month, 10),
  )} ${year} ${hour}:${minute}`;

  return formattedDate;
}

// Helper function to get month name
function getMonthName(month) {
  const monthNames = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember',
  ];

  return monthNames[month - 1] || '';
}

/*  ENd Custom Anthony -- Fungsi Load Sample Data Genangan */

function createDetailPanelStation(reading) {
  var photo = '/images/default-image.png';

  if (reading.image != null) {
    var photo = `/uploads/images/stations/${reading.image}`;
  }
  var status_offline =
    '<small class="mdi mdi-circle text-danger"></small> Offline';

  if (reading.status == 'online') {
    status_offline =
      '<small class="mdi mdi-circle text-success"></small> Online';
  }

  var panelContent = '<table class="table mb-2 font-12"><tbody>';

  panelContent += '<tr>';
  panelContent += `<td class="px-0 py-2" colspan="3">
                <div class="d-flex align-items-start">
            <img class="me-2 rounded-3" src="${appendImageVersion(photo)}" width="45" height="45" alt="${reading.name}">
                    <div class="w-100">
                        <h5 class="mt-0 mb-1 fw-semibold font-12">${reading.name}</h5>
                        ${status_offline}
                    </div>
                </div>
            </td>`;
  panelContent += '</tr>';

  panelContent += '<tr>';
  panelContent += `<td class="py-1 px-0">Merk Logger</td>`;
  panelContent += `<td class="py-1 px-2">:</td>`;
  panelContent += `<td class="py-1 px-0">${reading.brand_name} (${reading.device_id})</td>`;
  panelContent += '</tr>';

  if (reading.reading_at != null) {
    panelContent += '<tr>';
    panelContent += `<td class="py-1 px-0">Waktu</td>`;
    panelContent += `<td class="py-1 px-2">:</td>`;
    panelContent += `<td class="py-1 px-0">${moment(reading.reading_at)
      .locale('id')
      .format('D MMMM YYYY HH:mm')}</td>`;
    panelContent += '</tr>';

    if (reading.type == 'AWLR') {
      var water_level_elevation =
        reading.water_level_elevation == null
          ? '-'
          : `${reading.water_level_elevation} <sup>Mdpl</sup>`;
      var debit =
        reading.debit == null ? '-' : `${reading.debit} <sup>m3/s</sup>`;

      panelContent += '<tr>';
      panelContent += `<td class="py-1 px-0 nowrap">Tinggi Muka Air</td>`;
      panelContent += `<td class="py-1 px-2">:</td>`;
      panelContent += `<td class="py-1 px-0 fw-semibold">${reading.water_level} <sup>${reading.unit_display}</sup></td>`;
      panelContent += '</tr>';

      panelContent += '<tr>';
      panelContent += `<td class="py-1 px-0 nowrap">Elevasi Muka Air</td>`;
      panelContent += `<td class="py-1 px-2">:</td>`;
      panelContent += `<td class="py-1 px-0 fw-semibold">${water_level_elevation}</td>`;
      panelContent += '</tr>';

      panelContent += '<tr>';
      panelContent += `<td class="py-1 px-0 nowrap">Debit</td>`;
      panelContent += `<td class="py-1 px-2">:</td>`;
      panelContent += `<td class="py-1 px-0 fw-semibold">${debit}</td>`;
      panelContent += '</tr>';
    } else if (reading.type == 'ARR') {
      panelContent += '<tr>';
      panelContent += `<td class="py-1 px-0 nowrap">Curah Hujan</td>`;
      panelContent += `<td class="py-1 px-2">:</td>`;
      panelContent += `<td class="py-1 px-0 fw-semibold">${reading.rainfall} <sup>mm</sup></td>`;
      panelContent += '</tr>';

      panelContent += '<tr>';
      panelContent += `<td class="py-1 px-0 nowrap">Curah Hujan Min.</td>`;
      panelContent += `<td class="py-1 px-2">:</td>`;
      panelContent += `<td class="py-1 px-0 fw-semibold">${reading.rainfall_min} <sup>mm</sup></td>`;
      panelContent += '</tr>';

      panelContent += '<tr>';
      panelContent += `<td class="py-1 px-0 nowrap">Curah Hujan Maks.</td>`;
      panelContent += `<td class="py-1 px-2">:</td>`;
      panelContent += `<td class="py-1 px-0 fw-semibold">${reading.rainfall_max} <sup>mm</sup></td>`;
      panelContent += '</tr>';
    }
  }

  panelContent += '</tbody></table>';

  panelContent += `<div class="text-end"><a href="/StationDetail/Index?id=${reading.id}" target="_blank">Lihat Detail <i class="mdi mdi-arrow-right"></i></a></div>`;

  return panelContent;
}

function loadAwlrLastReading() {
  $('#group-awlr').empty();
  $('#group-awlr').html(loadShimmerLastReading);

  getData(`/Home/GetAwlrLastReading`)
    .then((res) => {
      $('#group-awlr').empty();
      let result = res.data;

      if (result.metaData.code == 200) {
        $('#total-awlr').html(result.response.length);
        $.each(result.response, function (key, awlr_last_reading) {
          var contentStation = loadContentAwlrLastReading(awlr_last_reading);
          if ($(`#card-station-${awlr_last_reading.id}`).length) {
            $(`#card-station-${awlr_last_reading.id}`).html(contentStation);
          } else {
            $('#group-awlr').append(`
                                <div class="card-station-awlr" data-ts-id="${
                                  awlr_last_reading.id
                                }" id="card-station-${
                                  awlr_last_reading.id
                                }" data-last-update="${
                                  awlr_last_reading.reading_at == null
                                    ? ''
                                    : moment(awlr_last_reading.reading_at)
                                        .locale('id')
                                        .format('YYYY-MM-DD HH:mm:ss')
                                }">
                                    ${contentStation}
                                </div>
                            `);
          }

          // Load Running Text
          if (awlr_last_reading.water_level != null) {
            var reading_at = new Date(awlr_last_reading.reading_at);
            var timeDifference = Math.abs(currentTime - reading_at);

            if (timeDifference <= maxDifference) {
              var running_text = getRunningText(awlr_last_reading);

              if (
                awlr_last_reading.warning_status == '3' ||
                awlr_last_reading.warning_status == '2' ||
                awlr_last_reading.warning_status == '1'
              ) {
                if ($('.running-text-awlr').length) {
                  $('#running-text-awlr').append(
                    `<span style="margin: 0 0.5rem;">•</span>`,
                  );
                }
                $('#running-text-awlr').append(running_text);
              }
            } else {
              console.log('marque gagal di loaded - awlr');
            }
          }
          let iconAwlr = '';
          if (
            awlr_last_reading.latitude != null &&
            awlr_last_reading.longitude != null
          ) {
            let alertSiaga = '';

            if (
              awlr_last_reading.siaga1 != null &&
              awlr_last_reading.status == 'online'
            ) {
              switch (awlr_last_reading.warning_status) {
                case '3':
                  iconAwlr = 'siaga_3.png';
                  alertSiaga = 'alert-siaga3';
                  break;
                case '2':
                  iconAwlr = 'siaga_2.png';
                  alertSiaga = 'alert-siaga2';
                  break;
                case '1':
                  iconAwlr = 'siaga_1.png';
                  alertSiaga = 'alert-siaga1';
                  break;
                default:
                  iconAwlr = 'siaga_4.png';
                  alertSiaga = '';
                  break;
              }
            }

            var customIcon = L.divIcon({
              iconSize: new L.Point(40, 20),
              iconAnchor: new L.Point(20, 20),
              html: `<div class="ts-marker-wrapper"><a href="javascript:void(0)" class="ts-marker ts-awlr" data-ts-id="64" data-ts-ln="60" style="outline: none;"><div class="ts-marker__title">${awlr_last_reading.name}</div><image class="${awlr_level_class}" src="${appendImageVersion(`/images/awlr/${iconAwlr}`)}" height="26" /></a></div>`,
            });

            var stationMarker = L.marker(
              [awlr_last_reading.latitude, awlr_last_reading.longitude],
              {
                icon: customIcon,
                warningStatus: awlr.warning_status,
              },
            )
              .bindPopup(createDetailPanelStation(awlr_last_reading))
              .addTo(awlr_marker);
          }

          // Add a custom attribute to the marker to associate it with the corresponding div
          stationMarker.options.id = awlr_last_reading.id;

          // Add a click event listener to the corresponding div
          //$('.card-station-awlr[data-ts-id="' + awlr_last_reading.id + '"]').on(
          //  "click",
          //  function () {
          //    map.setView(
          //      [awlr_last_reading.latitude, awlr_last_reading.longitude],
          //      12
          //    );
          //    stationMarker.openPopup();
          //    loadGrafik12Jam(awlr_last_reading.id, "awlr");
          //  }
          //);

          // Add a click event listener to the corresponding div
          $('.card-station-awlr[data-ts-id="' + awlr_last_reading.id + '"]').on(
            'click',
            function () {
              const lat = awlr_last_reading.latitude;
              const lng = awlr_last_reading.longitude;

              // 1. Arahkan peta ke lokasi
              map.setView([lat, lng], 12);

              // 2. Cek apakah marker ada di peta.
              // Jika layer group (awlr_marker) OFF, kita buat popup manual di koordinat tersebut.
              if (map.hasLayer(stationMarker)) {
                // Jika layer ON, buka seperti biasa
                stationMarker.openPopup();
              } else {
                // Jika layer OFF, buka popup mandiri (standalone) langsung ke map
                L.popup()
                  .setLatLng([lat, lng])
                  .setContent(createDetailPanelStation(awlr_last_reading))
                  .openOn(map);
              }

              loadGrafik12Jam(awlr_last_reading.id, 'awlr');
            },
          );
        });
      }
    })
    .catch((err) => {
      console.log(err.response);
    });
}

function getRunningText(reading) {
  var result = ``;
  if (reading.type == 'AWLR') {
    var change_status = '';
    var text_warning_status = '';

    switch (reading.change_status) {
      case 'increase':
        change_status =
          '<i class="mdi mdi-arrow-up-circle text-danger ms-1"></i>';
        break;
      case 'decrease':
        change_status =
          '<i class="mdi mdi-arrow-down-circle text-success ms-1"></i>';
        break;
    }

    if (reading.warning_status != null) {
      switch (reading.warning_status) {
        //bakupaku
        case '0':
          text_warning_status =
            '<span class="fw-semibold ms-1" style="color: #4DC27E;"> Normal</span>';
          break;
        case '1':
          text_warning_status =
            '<span class="fw-semibold ms-1" style="color: #F40A07;"> AWAS</span>';
          break;
        case '2':
          text_warning_status =
            '<span class="fw-semibold ms-1" style="color: #FDFE01;"> SIAGA</span>';
          break;
        case '3':
          text_warning_status =
            '<span class="fw-semibold ms-1" style="color: #09FE02;"> WASPADA</span>';
          break;
      }
    }

    result = `<span class="running-text-awlr" id="running-text-${reading.id}"> ${reading.name} : ${change_status} <span style="color: #D0D1D8;">${reading.water_level} ${reading.unit_display}</span> ${text_warning_status} </span>`;
  } else if (reading.type == 'ARR') {
    var text_intensity = '';

    if (reading.intensity_last_hour != null) {
      switch (reading.intensity_last_hour) {
        case 'Cerah':
        case 'Berawan':
        case 'Tidak Hujan':
          text_intensity =
            '<span class="fw-semibold ms-1" style="color: #959392;"> Cerah</span>';
          break;
        case 'Hujan Ringan':
          text_intensity =
            '<span class="fw-semibold ms-1" style="color: #1abc9c;"> Hujan Ringan</span>';
          break;
        case 'Hujan Sedang':
          text_intensity =
            '<span class="fw-semibold ms-1" style="color: #f7b84b;"> Hujan Sedang</span>';
          break;
        case 'Hujan Lebat':
          text_intensity =
            '<span class="fw-semibold ms-1" style="color: #FF781F;"> Hujan Lebat</span>';
          break;
        case 'Hujan Sangat Lebat':
          text_intensity =
            '<span class="fw-semibold ms-1" style="color: #f1556c;"> Hujan Sangat Lebat</span>';
          break;
      }
    }

    result = `<span class="running-text-arr" id="running-text-${reading.id}"> ${reading.name} : <span style="color: #D0D1D8;">${reading.rainfall_last_hour} mm</span> ${text_intensity} </span>`;
  }

  return result;
}

function loadArrLastReading() {
  $('#group-arr').empty();
  $('#group-arr').html(loadShimmerLastReading);
  getData(`/Home/GetArrLastReading`)
    .then((res) => {
      $('#group-arr').empty();
      let result = res.data;

      if (result.metaData.code == 200) {
        $('#total-arr').html(result.response.length);
        $.each(result.response, function (key, arr_last_reading) {
          var contentStation = loadContentArrLastReading(arr_last_reading);
          if ($(`#card-station-${arr_last_reading.id}`).length) {
            $(`#card-station-${arr_last_reading.id}`).html(contentStation);
          } else {
            $('#group-arr').append(`
                                <div class="card-station-arr" data-ts-id="${
                                  arr_last_reading.id
                                }" id="card-station-${
                                  arr_last_reading.id
                                }" data-last-update="${
                                  arr_last_reading.reading_at == null
                                    ? ''
                                    : moment(arr_last_reading.reading_at)
                                        .locale('id')
                                        .format('YYYY-MM-DD HH:mm:ss')
                                }">
                                    ${contentStation}
                                </div>
                            `);
          }

          // Load Running Text
          if (arr_last_reading.rainfall_last_hour != null) {
            var reading_at = new Date(arr_last_reading.reading_at);
            var timeDifference = Math.abs(currentTime - reading_at);

            if (timeDifference <= maxDifference) {
              var running_text = getRunningText(arr_last_reading);

              if (arr_last_reading.rainfall > 20) {
                $('#running-text-arr').append(
                  `<span style="margin: 0 0.5rem;">•</span>`,
                );
                $('#running-text-arr').append(running_text);
              }
            }
          }

          if (
            arr_last_reading.latitude != null &&
            arr_last_reading.longitude != null
          ) {
            var customIcon = L.divIcon({
              iconSize: new L.Point(40, 20),
              iconAnchor: new L.Point(20, 20),
              html: `<div class="ts-marker-wrapper"><a href="javascript:void(0)" class="ts-marker ts-arr" data-ts-id="64" data-ts-ln="60" style="outline: none;"><div class="ts-marker__title">${
                arr_last_reading.name
              }</div><image src="${appendImageVersion(
                `/images/intensity/${getIntensityIcon(
                  arr_last_reading.intensity_last_hour,
                )}`,
              )}" height="25" /></a></div>`,
            });

            var stationMarker = L.marker(
              [arr_last_reading.latitude, arr_last_reading.longitude],
              {
                icon: customIcon,
                intensityStatus: normalizeIntensityStatus(
                  arr_last_reading.intensity_last_hour,
                ),
              },
            )
              .bindPopup(createDetailPanelStation(arr_last_reading))
              .addTo(arr_marker);
          }

          // Add a custom attribute to the marker to associate it with the corresponding div
          stationMarker.options.id = arr_last_reading.id;

          // Add a click event listener to the corresponding div
          //$('.card-station-arr[data-ts-id="' + arr_last_reading.id + '"]').on(
          //  "click",
          //  function () {
          //    map.setView(
          //      [arr_last_reading.latitude, arr_last_reading.longitude],
          //      12
          //    );
          //    stationMarker.openPopup();
          //    loadGrafik12Jam(arr_last_reading.id, "arr");
          //  }
          //);

          $('.card-station-arr[data-ts-id="' + arr_last_reading.id + '"]').on(
            'click',
            function () {
              const latlng = [
                arr_last_reading.latitude,
                arr_last_reading.longitude,
              ];

              // Pindahkan view peta
              map.setView(latlng, 12);

              // Munculkan popup langsung di koordinat tersebut
              L.popup()
                .setLatLng(latlng)
                .setContent(stationMarker.getPopup().getContent()) // Mengambil konten dari popup marker yang sudah ada
                .openOn(map);

              loadGrafik12Jam(arr_last_reading.id, 'arr');
            },
          );
        });
      }
    })
    .catch((err) => {
      console.log(err.response);
    });
}

function loadContentAwlrLastReading(awlr_last_reading) {
  // Reading
  var wl_elevation_operator =
    awlr_last_reading.water_level_elevation > 0 ? '+' : '';
  var change_status = '';
  switch (awlr_last_reading.change_status) {
    case 'increase':
      change_status =
        '<i class="mdi mdi-arrow-up-circle text-danger me-1"></i>';
      break;
    case 'decrease':
      change_status =
        '<i class="mdi mdi-arrow-down-circle text-success me-1"></i>';
      break;
  }

  // Warning Status
  var class_warning_status = '';
  var text_warning_status =
    '<h4 class="reading-at text-uppercase fst-italic fw-semibold" style="color: #349EE0;">Tanpa Status</h4>';
  switch (awlr_last_reading.warning_status) {
    case '0':
      text_warning_status =
        '<h4 class="reading-at text-uppercase fw-bold" style="color: #4DC27E;">Normal</h4>';
      class_warning_status = 'normal';
      break;
    case '1':
      text_warning_status =
        '<h4 class="reading-at text-uppercase fw-bold" style="color: #EF5350;">Awas (Siaga 1)</h4>';
      class_warning_status = 'siaga1';
      break;
    case '2':
      text_warning_status =
        '<h4 class="reading-at text-uppercase fw-bold" style="color: #FFA600;">Siaga (Siaga 2)</h4>';
      class_warning_status = 'siaga2';
      break;
    case '3':
      text_warning_status =
        '<h4 class="reading-at text-uppercase fw-bold" style="color: #FFDA4F;">Waspada (Siaga 3)</h4>';
      class_warning_status = 'siaga3';
      break;
  }

  var water_level =
    awlr_last_reading.water_level != null
      ? `<h4 class="text-status-${class_warning_status}">${change_status} ${awlr_last_reading.water_level.toFixed(
          2,
        )} <sup>${awlr_last_reading.unit_display}</sup></h4>`
      : '-';
  var water_level_elevation =
    awlr_last_reading.water_level_elevation != null
      ? `${wl_elevation_operator}${awlr_last_reading.water_level_elevation} <sup>mdpl</sup>`
      : '-';
  var debit =
    awlr_last_reading.debit != null
      ? `${awlr_last_reading.debit} <sup>m<sup>3</sup>/s</sup>`
      : '-';

  // Device
  var device_status = `<small class="mdi mdi-cancel text-danger"></small> Offline `;
  if (awlr_last_reading.status == 'online') {
    device_status = `<small class="mdi mdi-circle text-success"></small> Online `;
  }

  // Location
  var region = '';
  var array_region = [];
  if (awlr_last_reading.village_name != null) {
    array_region.push(toTitleCase(awlr_last_reading.village_name));
  }
  if (awlr_last_reading.district_name != null) {
    array_region.push(`Kec. ${toTitleCase(awlr_last_reading.district_name)}`);
  }
  if (awlr_last_reading.regency_name != null) {
    array_region.push(
      toTitleCase(awlr_last_reading.regency_name).replace(/Kabupaten/g, 'Kab.'),
    );
  }
  if (awlr_last_reading.province_name != null) {
    array_region.push(toTitleCase(awlr_last_reading.province_name));
  }

  if (array_region.length > 0) {
    region = '<br/> ' + array_region.join(', ');
  }

  // Level Warning
  var warning_status_bar = '';
  if (
    awlr_last_reading.siaga1 != null &&
    awlr_last_reading.siaga2 != null &&
    awlr_last_reading.siaga3 != null
  ) {
    warning_status_bar = `
                    <div class="progress-meter mt-2 mb-2">
                        <div class="meter meter-normal meter-left" style="width: 25%;" title="Normal <br> < 6 m"><span class="fw-normal meter-text" style="color: #12cdfc;">0</span></div>
                        <div class="meter meter-waspada meter-left" style="width: 25%;" title="Siaga 3 <br> ${awlr_last_reading.siaga3} ${awlr_last_reading.unit_display} - ${awlr_last_reading.siaga2} ${awlr_last_reading.unit_display}"><span class="fw-normal meter-text" style="color: #09FE02;">${awlr_last_reading.siaga3} ${awlr_last_reading.unit_display}</span></div>
                        <div class="meter meter-siaga meter-left" style="width: 25%;" title="Siaga 2 <br> ${awlr_last_reading.siaga2} ${awlr_last_reading.unit_display} - ${awlr_last_reading.siaga1} ${awlr_last_reading.unit_display}"><span class="fw-normal meter-text" style="color: #FDFE01;">${awlr_last_reading.siaga2} ${awlr_last_reading.unit_display}</span></div>
                        <div class="meter meter-awas meter-left" style="width: 25%;" title="Siaga 1 <br> > ${awlr_last_reading.siaga1} ${awlr_last_reading.unit_display}"><span class="fw-normal meter-text" style="color: #F40A07;">${awlr_last_reading.siaga1} ${awlr_last_reading.unit_display}</span></div>
                    </div>
                `;
  }

  var card_header = `<div class="card-header text-center">
                <span class="reading-at fst-italic">Data belum tersedia</span>
            </div>`;

  if (awlr_last_reading.reading_at != null) {
    const currentDate = moment().format('YYYY-MMM-DD');
    var reading_at = '';

    if (
      moment(awlr_last_reading.reading_at).format('YYYY-MMM-DD') == currentDate
    ) {
      reading_at = `Hari Ini <span class="text-muted">${moment(
        awlr_last_reading.reading_at,
      ).format('HH:mm')}</span>`;
    } else {
      reading_at = moment(awlr_last_reading.reading_at)
        .locale('id')
        .format('D MMMM YYYY HH:mm');
    }

    card_header = `
                    <div class="card-header">
                        <div class="d-flex align-items-center">
                            ${text_warning_status}
                            <span class="reading-at ms-auto">${reading_at}</span>
                        </div>
                    </div>
                `;
  }

  var battery = '';
  if (awlr_last_reading.battery != null) {
    battery = `<small class="mdi mdi-battery-charging-high ms-1" style="color: #F69696;"></small> ${awlr_last_reading.battery}`;
  }

  return `
                <div class="card card-station  mb-1">
                    ${card_header}
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-start mb-1">
                            <div class="d-flex align-items-center">
                                <div class="w-100">
                                    <h4 class="card-title text-station-name m-0 mb-1">${awlr_last_reading.name}</h4>
                                </div>
                            </div>
                            <span class="reading-at text-end">
                                ${device_status}
                            </span>
                        </div>
                        <p class="reading-device d-flex align-items-center mb-1">
                            <i class="fe-hard-drive me-1" style="padding-bottom: 0.15rem;"></i>
                            <span>
                                ${awlr_last_reading.brand_name} - ${awlr_last_reading.device_id} 
                                ${battery}
                            </span>
                        </p>
                        <p class="reading-device d-flex align-items-start mb-1">
                            <i class="fe-map-pin me-1" style="padding-top: 0.15rem;"></i>
                            <span>${awlr_last_reading.watershed_name} ${region}</span>
                        </p>
                        <div class="d-flex justify-content-around align-items-center reading-text">
                            <div class="col-4 text-center">
                                ${water_level}
                            </div>
                            <div class="col-4 text-center">
                                <h4>${water_level_elevation}</h4>
                            </div>
                            <div class="col-4 text-center">
                                <h4>${debit}</h4>
                            </div>
                        </div>
                        <div class="d-flex justify-content-around reading-text">
                            <div class="col-4 text-center">
                                Tinggi Muka Air
                            </div>
                            <div class="col-4 text-center">
                                Elevasi Muka Air
                            </div>
                            <div class="col-4 text-center">
                                Debit
                            </div>
                        </div>
                        ${warning_status_bar}
                    </div>
                </div>
            `;
}

function loadContentArrLastReading(arr_last_reading) {
  // Device
  var device_status = `<small class="mdi mdi-cancel text-danger"></small> Offline `;
  if (arr_last_reading.status == 'online') {
    device_status = `<small class="mdi mdi-circle text-success"></small> Online `;
  }

  // Location
  var region = '';
  var array_region = [];
  if (arr_last_reading.village_name != null) {
    array_region.push(toTitleCase(arr_last_reading.village_name));
  }
  if (arr_last_reading.district_name != null) {
    array_region.push(`Kec. ${toTitleCase(arr_last_reading.district_name)}`);
  }
  if (arr_last_reading.regency_name != null) {
    array_region.push(
      toTitleCase(arr_last_reading.regency_name).replace(/Kabupaten/g, 'Kab.'),
    );
  }
  if (arr_last_reading.province_name != null) {
    array_region.push(toTitleCase(arr_last_reading.province_name));
  }

  if (array_region.length > 0) {
    region = '<br/> ' + array_region.join(', ');
  }

  // Intensitas Per Jam
  var intensity_per_hour = ``;

  if (arr_last_reading.rainfall_last_hour) {
    if (arr_last_reading.rainfall_last_hour > 100) {
      arr_last_reading.intensity_last_hour = 'Hujan Ekstrem';
    }
  }

  var intensityLabel = normalizeIntensityStatus(
    arr_last_reading.intensity_last_hour,
  );

  if (
    arr_last_reading.rainfall_last_hour != null &&
    arr_last_reading.intensity_last_hour != null
  ) {
    intensity_per_hour = `
                    <h4 class="text-center" style="font-size: 0.7rem;">Intensitas Per Jam :</h4>
                    <div class="d-flex justify-content-around align-items-center reading-text mb-1">
                        <div class="col-4 text-center">
                            <h4 class="text-range-hour">${moment(
                              arr_last_reading.reading_hour,
                            ).format('HH:mm')} - ${moment(
                              arr_last_reading.reading_at,
                            ).format('HH:mm')}</h4>
                        </div>
                        <div class="col-4 text-center">
                            <h4>${
                              arr_last_reading.rainfall_last_hour
                            } <sup>mm</sup></h4>
                        </div>
                        <div class="col-4 col-intensity text-center">
                            <img src="${appendImageVersion(
                              `/images/intensity/${getIntensityIcon(
                                intensityLabel,
                              )}`,
                            )}" alt="${intensityLabel}">
                        </div>
                    </div>
                    <div class="d-flex justify-content-around reading-text">
                        <div class="col-4 text-center">
                            Jam
                        </div>
                        <div class="col-4 text-center">
                            Curah Hujan
                        </div>
                        <div class="col-4 text-center fst-italic">
                            ${intensityLabel}
                        </div>
                    </div>
                `;
  }

  var card_header = `<div class="card-header text-center">
                <span class="reading-at fst-italic">Data belum tersedia</span>
            </div>`;

  if (arr_last_reading.reading_at != null) {
    const currentDate = moment().format('YYYY-MMM-DD');
    var reading_at = '';

    if (
      moment(arr_last_reading.reading_at).format('YYYY-MMM-DD') == currentDate
    ) {
      reading_at = `Hari Ini <span class="text-muted">${moment(
        arr_last_reading.reading_at,
      ).format('HH:mm')}</span>`;
    } else {
      reading_at = moment(arr_last_reading.reading_at)
        .locale('id')
        .format('D MMMM YYYY HH:mm');
    }
    card_header = `
                    <div class="card-header">
                        <div class="d-flex align-items-center">
                            <h4 class="reading-at">Data Per 5 Menit: ${arr_last_reading.rainfall} mm</h4>
                            <span class="reading-at ms-auto">${reading_at}</span>
                        </div>
                    </div>
                `;
  }

  var battery = '';
  if (arr_last_reading.battery_voltage != null) {
    battery = `<small class="mdi mdi-battery-charging-high ms-1" style="color: #F69696;"></small> ${arr_last_reading.battery_voltage}`;
  }

  return `
                <div class="card card-station  mb-1">
                    ${card_header}
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-start mb-1">
                            <div class="d-flex align-items-center">
                                <div class="w-100">
                                    <h4 class="card-title text-station-name m-0 mb-1">${arr_last_reading.name}</h4>
                                </div>
                            </div>
                            <span class="reading-at text-end">
                                ${device_status}

                            </span>
                        </div>
                        <p class="reading-device d-flex align-items-center mb-1">
                            <i class="fe-hard-drive me-1" style="padding-bottom: 0.15rem;"></i>
                            <span>
                                ${arr_last_reading.brand_name} - ${arr_last_reading.device_id} 
                                ${battery}
                            </span>
                        </p>
                        <p class="reading-device d-flex align-items-start mb-1">
                            <i class="fe-map-pin me-1" style="padding-top: 0.15rem;"></i>
                            <span>${arr_last_reading.watershed_name} ${region}</span>
                        </p>
                        ${intensity_per_hour}
                    </div>
                </div>
            `;
}

function loadCctv() {
  const REFRESH_INTERVAL_MS = 5 * 60 * 1000;

  // ========================================================
  // MEMUAT ULANG STREAM (Langsung Load tanpa cek status)
  // ========================================================
  function reloadStream(url, type) {
    const video = document.getElementById('popupVideoPlayer');
    const img = document.getElementById('popupImagePlayer');
    const status = document.getElementById('refreshStatus');

    if (!video || !img) return;

    // Reset tampilan
    video.style.display = 'none';
    img.style.display = 'none';

    if (type === 'mjpeg') {
      video.pause();
      img.style.display = 'block';
      img.src = url + (url.includes('?') ? '&' : '?') + 't=' + Date.now();
      img.onload = () => (status.innerText = 'Stream aktif (MJPEG)');
      img.onerror = () => (status.innerText = 'Gagal memuat MJPEG.');
    } else {
      // Default ke MP4/Video
      video.style.display = 'block';
      video.src = url;
      video.load();
      video
        .play()
        .then(() => (status.innerText = 'Stream aktif (MP4)'))
        .catch(() => {
          status.innerText = 'Gagal memutar video.';
        });
    }
  }

  const FALLBACK_SVG_HTML = (isPopup, cctvId) => `
        <div class="cctv-fallback item cctv-${cctvId}" 
            style="background:linear-gradient(135deg,#2c3e50,#34495e); height:100%;width:100%;position:relative;display:flex; align-items:center;justify-content:center;">
            <svg width="${isPopup ? '120' : '80'}" height="${
              isPopup ? '120' : '80'
            }" viewBox="0 0 80 80">
                <circle cx="40" cy="40" r="38" stroke="rgba(255,255,255,.5)" stroke-width="3" fill="none"/>
                <path d="M32 25 L32 55 L55 40 Z" fill="rgba(255,255,255,.5)"/>
            </svg>
        </div>
    `;

  function getStreamHtml(cctv, isPopup = false) {
    const elementId = isPopup ? 'popup' : cctv.id;
    const streamUrl =
      cctv.video_url +
      (cctv.video_url.includes('?') ? '&' : '?') +
      't=' +
      Date.now();

    if (cctv.stream_type === 'mjpeg') {
      return `
                <img class="cctv-stream-img" 
                    id="cctv-img-${elementId}"
                    data-cctv-id="${cctv.id}"
                    src="${appendImageVersion(streamUrl)}" 
                    style="display:block;height:100%;width:100%;object-fit:cover;"
                    onerror="this.style.display='none'; $(this).siblings('.cctv-fallback').show();" />
                ${FALLBACK_SVG_HTML(isPopup, cctv.id).replace(
                  'display:flex;',
                  'display:none;',
                )} 
            `;
    }
    return FALLBACK_SVG_HTML(isPopup, cctv.id);
  }

  // ========================================================
  // MAIN FETCH CCTV LIST (Langsung Render)
  // ========================================================
  getData(`/Home/GetAllCctvsDki`).then((res) => {
    const result = res.data;
    if (result.metaData.code !== 200) return;

    $('#total-cctv').text(result.response.cctvDki.length);
    $('#image-cctv').empty();

    const cctvs = result.response.cctvDki;
    let content = '';

    for (let i = 0; i < cctvs.length; i += 2) {
      const left = cctvs[i];
      const right = cctvs[i + 1];

      content += `<div class="row mb-1" style="background-color:#222; height:18vh!important;">`;

      function tile(cctv, side) {
        return `
                <div class="col-6 px-0 d-flex align-items-center justify-content-center" style="padding-${side}:1.5px!important;">
                    <a class="open-cctv-video cctv-thumbnail-wrapper"
                        style="display:inline-block;height:90%;width:100%;position:relative;" 
                        data-cctv-url="${cctv.video_url}"
                        data-cctv-name="${cctv.name}"
                        data-stream-type="${cctv.stream_type || 'mp4'}"
                        href="#video-popup-placeholder">
                        ${getStreamHtml(cctv, false)} 
                        <div style="background:rgba(0,0,0,.7);color:white;padding:5px 8px;position:absolute;bottom:0;left:0;right:0;">
                            <span style="font-size:.75rem;font-weight:200;">${
                              cctv.name
                            }</span>
                        </div>
                    </a>
                </div>`;
      }

      content += tile(left, 'right');
      if (right) content += tile(right, 'left');
      else content += `<div class="col-6 px-0"></div>`;

      content += '</div>';
    }

    $('#image-cctv').html(content);

    // ========================================================
    // MAGNIFIC POPUP (Langsung Buka)
    // ========================================================
    $('.open-cctv-video').magnificPopup({
      type: 'inline',
      midClick: true,
      mainClass: 'mfp-fade',
      callbacks: {
        beforeOpen: function () {
          $('#popupTitle').text(this.st.el.data('cctv-name'));
        },
        open: function () {
          const el = this.st.el;
          const url = el.data('cctv-url');
          const type = el.data('stream-type');

          reloadStream(url, type);

          window.videoRefreshInterval = setInterval(() => {
            reloadStream(url, type);
          }, REFRESH_INTERVAL_MS);
        },
        close: function () {
          const video = document.getElementById('popupVideoPlayer');
          const img = document.getElementById('popupImagePlayer');
          if (video) {
            video.pause();
            video.src = '';
          }
          if (img) {
            img.src = '';
          }
          clearInterval(window.videoRefreshInterval);
        },
      },
    });
  });
}

function loadCctvDummy() {
  const REFRESH_INTERVAL_MS = 5 * 60 * 1000;
  const container = $('#image-cctv'); // Sesuaikan dengan ID kontainer Anda

  // 1. Ambil data melalui AJAX
  $.ajax({
    url: '/Home/GetMonitoringCCTV',
    type: 'GET',
    dataType: 'json',
    success: function (response) {
      $('.shimmer-item').remove();
      renderThumbnails(response);
      $('#total-cctv').text(response.length);
      initCctvPopup();
    },
    error: function (xhr, status, error) {
      console.error('Gagal memuat data CCTV:', error);
    },
  });

  // 2. Fungsi Render Thumbnail (Struktur baris per baris dengan 2 kolom)
  //function renderThumbnails(data) {
  //  let content = "";

  //  for (let i = 0; i < data.length; i += 2) {
  //    const left = data[i];
  //    const right = data[i + 1];

  //    // Menggunakan row mb-1 sesuai inspirasi dummy
  //    content += `<div class="row mb-1 cctv-row" style="background-color:#222; min-height:18vh!important;">`;

  //    const createTile = (cctv, side) => {
  //      if (!cctv) return `<div class="col-6 px-0"></div>`;

  //      const locationName = cctv.name || `CCTV ${i + 1}`;
  //      const thumbUrl = `${cctv.url}&mode=single&t=${Date.now()}`;

  //      return `
  //        <div class="col-6 px-0 d-flex align-items-center justify-content-center" style="padding-${side}:1.5px!important;">
  //          <a class="open-cctv-video cctv-thumbnail-wrapper"
  //             style="display:inline-block; height:90%; width:100%; position:relative; overflow:hidden;"
  //             data-cctv-url="${cctv.url}"
  //             data-cctv-name="${locationName}"
  //             href="#video-popup-placeholder">

  //             <img src="${thumbUrl}"
  //                  data-retry="0"
  //                  style="width:100%; height:100%; object-fit:cover;"
  //                  onerror="handleCctvError(this, '${thumbUrl}')">

  //             <div style="position:absolute; top:50%; left:50%; transform:translate(-50%, -50%); opacity:0.7;">
  //                <svg width="40" height="40" viewBox="0 0 24 24" fill="white">
  //                  <path d="M8 5v14l11-7z"/>
  //                </svg>
  //             </div>

  //             <div style="background:rgba(0,0,0,.7); color:white; padding:5px 8px; position:absolute; bottom:0; left:0; right:0;">
  //                <span style="font-size:.75rem; font-weight:200; display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
  //                  ${locationName}
  //                </span>
  //             </div>
  //          </a>
  //        </div>`;
  //    };

  //    content += createTile(left, "right");
  //    content += createTile(right, "left");
  //    content += "</div>";
  //  }
  //  container.html(content);
  //}

  function renderThumbnails(data) {
    let content = '';

    data.forEach((cctv, i) => {
      const locationName = cctv.name || `CCTV ${i + 1}`;
      const thumbUrl = `${cctv.url}&mode=single&t=${Date.now()}`;

      content += `
        <div class="cctv-card-wrapper" data-cctv-name="${locationName}" style="padding: 2px 2px;">
            <a class="open-cctv-video cctv-thumbnail-wrapper"
               style="display:block; width:100%; position:relative; padding-top:56.25%; overflow:hidden;"
               data-cctv-url="${cctv.url}"
               data-cctv-name="${locationName}"
               href="#video-popup-placeholder">

      <img src="${appendImageVersion(thumbUrl)}"
                    data-retry="0"
                    style="position:absolute; top:0; left:0; width:100%; height:100%; object-fit:cover;"
        onerror="handleCctvError(this, '${appendImageVersion(thumbUrl)}')">

               <div style="position:absolute; top:50%; left:50%; transform:translate(-50%,-50%); opacity:0.7;">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="white">
                    <path d="M8 5v14l11-7z"/>
                  </svg>
               </div>

               <div style="background:rgba(0,0,0,.7); color:white; padding:5px 8px; position:absolute; bottom:0; left:0; right:0;">
                  <span style="font-size:.75rem; font-weight:200; display:block; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                    ${locationName}
                  </span>
               </div>
            </a>
        </div>`;
    });

    container.html(content);

    // CSS Grid otomatis: min 150px per card, max 2 kolom di sidebar sempit
    container.css({
      display: 'grid',
      'grid-template-columns': 'repeat(2, 1fr)',
      gap: '2px 4px', // vertical 2px, horizontal 4px
      padding: '0 4px', // jarak kiri kanan container
    });
  }

  // 3. Fungsi Refresh Stream untuk Popup
  function reloadPopupStream(url) {
    const img = document.getElementById('popupImagePlayer');
    const status = document.getElementById('refreshStatus');

    if (img) {
      img.style.display = 'block';
      // Live stream tanpa mode=single
      img.src = `${url}&t=${Date.now()}`;
      if (status) status.innerText = 'Stream Aktif (Live MJPEG)';
    }
  }

  // 4. Inisialisasi Magnific Popup
  function initCctvPopup() {
    $('.open-cctv-video').magnificPopup({
      type: 'inline',
      midClick: true,
      mainClass: 'mfp-fade',
      callbacks: {
        beforeOpen: function () {
          // Mengambil nama dari data attribute elemen yang diklik
          $('#popupTitle').text(this.st.el.data('cctv-name'));
        },
        open: function () {
          const url = this.st.el.data('cctv-url');
          reloadPopupStream(url);

          // Interval refresh otomatis
          window.videoRefreshInterval = setInterval(() => {
            reloadPopupStream(url);
          }, REFRESH_INTERVAL_MS);
        },
        close: function () {
          const img = document.getElementById('popupImagePlayer');
          if (img) img.src = '';
          clearInterval(window.videoRefreshInterval);
        },
      },
    });
  }
}

function loadShimmerLastReading() {
  var totalShimmer = 5;
  var contentShimmer = ``;

  for (let i = 1; i <= totalShimmer; i++) {
    contentShimmer += `<div class="card card-station mb-2">
                    <div class="card-body">
                        <div class="d-flex justify-content-start mb-2">
                            <box class="shine me-2" style="width: 3rem;height: 3rem;"></box>
                            <div class="col-md-8">
                                <div class="box-shine-3 shine m-0"></div>
                                <div class="box-shine-1 shine m-0"></div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-around reading-text mb-2">
                            <div class="text-center">
                                <div class="box-shine-1 shine" style="width: 3rem;"></div>
                                <br>
                                <div class="box-shine-2 shine" style="width: 5rem;"></div>
                            </div>
                            <div class="text-center">
                                <div class="box-shine-1 shine" style="width: 3rem;"></div>
                                <br>
                                <div class="box-shine-2 shine" style="width: 5rem;"></div>
                            </div>
                            <div class="text-center">
                                <div class="box-shine-1 shine" style="width: 3rem;"></div>
                                <br>
                                <div class="box-shine-2 shine" style="width: 5rem;"></div>
                            </div>
                        </div>
                        <div class="box-shine-3 shine"></div>
                    </div>
                </div>`;
  }

  return `
                <div class="row">
                    <div class="col-12">
                        ${contentShimmer}
                    </div>
                </div>
            `;
}

function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    if (txt == 'DKI') {
      return txt;
    }
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function normalizeIntensityStatus(status) {
  if (!status || status === 'Berawan' || status === 'Tidak Hujan') {
    return 'Cerah';
  }
  return status;
}

function getIntensityIcon(status) {
  let icon = 'berawan.png';
  switch (status) {
    case 'Cerah':
    case 'Berawan':
    case 'Tidak Hujan':
      icon = 'berawan-siang.png';
      break;

    case 'Hujan Ringan':
      icon = 'hujan-ringan.png';
      break;

    case 'Hujan Sedang':
      icon = 'hujan-sedang.png';
      break;

    case 'Hujan Lebat':
      icon = 'hujan-lebat.png';
      break;

    case 'Hujan Sangat Lebat':
      icon = 'hujan-sangat-lebat.png';
      break;
    case 'Hujan Sangat Lebat':
      icon = 'hujan-sangat-lebat.png';
      break;
    case 'Hujan Ekstrem':
      icon = 'hujan-ekstrem.png';
      break;
    default:
      icon = 'berawan-siang-outline.png';
      break;
  }

  return icon;
}

function updateClock() {
  // Dapatkan elemen berarkan ID
  var tglElement = document.getElementById('tgl_genangan');
  var jamElement = document.getElementById('jam_genangan');

  // Dapatkan tanggal dan waktu saat ini
  var now = new Date();

  // Format tanggal (misal: 11 November 2023)
  var options = { day: 'numeric', month: 'long', year: 'numeric' };
  var formattedDate = now.toLocaleDateString('id-ID', options);

  // Format jam dan menit (misal: 14:30)
  var formattedTime = now.getHours().toString().padStart(2, '0') + ':00';

  // Setel teks elemen dengan tanggal dan waktu yang diformat
  tglElement.innerText = formattedDate;
  jamElement.innerText = formattedTime;
}

function generateOfflineAwlr(awlr_last_reading) {
  var contentStation = loadContentAwlrLastReading2(awlr_last_reading);
  var awlrIcon = 'siaga_4.png';
  if ($(`#card-station-${awlr_last_reading.id}`).length) {
    $(`#card-station-${awlr_last_reading.id}`).html(contentStation);
  } else {
    if (awlr_last_reading.id == null) {
      $(`#tab-offline`).append(contentStation);
    } else {
      if (
        $(`#offline-river-area-${awlr_last_reading.river_area_id}`).length == 0
      ) {
        $('#tab-offline')
          .append(`<h4 class="text-center m-0" style="padding: 0.7rem;font-size: 0.8rem;background-color: #2F3567;" id="offline-river-area-${
          awlr_last_reading.river_area_id
        }">
                            <span style="color: #CDCED5;">${
                              awlr_last_reading.river_area_code == ''
                                ? ''
                                : awlr_last_reading.river_area_code + ' : '
                            } </span>
                            <span class="ms-1" style="color: #CDCED5;"> ${
                              awlr_last_reading.river_area_name
                            }</span>
                        </h4>
                        <div class="accordion custom-accordion" id="offline-accordion-${
                          awlr_last_reading.river_area_id
                        }">
                        </div>`);
      }

      if (
        $(`#offline-watershed-${awlr_last_reading.watershed_id}`).length == 0
      ) {
        $(`#offline-accordion-${awlr_last_reading.river_area_id}`)
          .append(`<div class="card mb-0">
                            <div class="card-header card-header-watershed">
                                <h5 class="m-0 position-relative">
                                    <a class="custom-accordion-title d-block d-flex align-items-center"
                                        data-bs-toggle="collapse" href="#offline-watershed-${
                                          awlr_last_reading.watershed_id
                                        }"
                                        aria-expanded="true" aria-controls="offline-watershed-${
                                          awlr_last_reading.watershed_id
                                        }">
                                        <span style="color: #0ECAF0;font-weight: 600">#${
                                          awlr_last_reading.watershed_code == ''
                                            ? ''
                                            : awlr_last_reading.watershed_code +
                                              ' : '
                                        } </span>
                                        <span class="ms-1" style="color: #FFC10A;font-weight: 400;">${
                                          awlr_last_reading.watershed_name
                                        }</span>
                                        <i class="mdi mdi-chevron-down accordion-arrow" style="color: #D0D1D8;"></i>
                                    </a>
                                </h5>
                            </div>

                            <div id="offline-watershed-${
                              awlr_last_reading.watershed_id
                            }" class="collapse show">
                                <div class="card-body content-watershed" style="border-bottom: 1px solid #293067;padding: 0;">

                                </div>
                            </div>
                        </div>`);
      }

      $(
        `#offline-watershed-${awlr_last_reading.watershed_id} .content-watershed`,
      ).append(contentStation);
    }
  }

  if (
    awlr_last_reading.latitude != null &&
    awlr_last_reading.longitude != null
  ) {
    let awlr_level_class = '';

    switch (awlr_last_reading.warning_status) {
      case '0':
        awlrIcon = 'siaga_4.png';
        awlr_level_class = '';
        break;
      case '3':
        awlrIcon = 'siaga_3.png';
        awlr_level_class = 'alert-siaga3';
        break;
      case '2':
        awlrIcon = 'siaga_2.png';
        awlr_level_class = 'alert-siaga2';
        break;
      case '1':
        awlrIcon = 'siaga_1.png';
        awlr_level_class = 'alert-siaga1';
        break;
      default:
        awlr_level_class = '';
        awlrIcon = 'siaga_4.png';
        break;
    }
    var customIcon = L.divIcon({
      iconSize: new L.Point(40, 20),
      iconAnchor: new L.Point(20, 20),
      html: `<div class="ts-marker-wrapper"><a href="javascript:void(0)" class="ts-marker ts-arr" data-ts-id="64" data-ts-ln="60" style="outline: none;"><div class="ts-marker__title">${awlr_last_reading.name}</div><image class="${awlr_level_class}" src="${appendImageVersion(`/images/awlr/${awlrIcon}`)}" height="28" /></a></div>`,
    });

    var stationMarker = L.marker(
      [awlr_last_reading.latitude, awlr_last_reading.longitude],
      {
        icon: customIcon,
      },
    )
      .bindPopup(createDetailPanelStation2(awlr_last_reading))
      .addTo(awlr_marker);
  }

  // Add a custom attribute to the marker to associate it with the corresponding div
  stationMarker.options.id = awlr_last_reading.id;

  // Add a click event listener to the corresponding div
  $('.card-station-awlr[data-ts-id="' + awlr_last_reading.id + '"]').on(
    'click',
    function () {
      alert('1');
      map.setView(
        [awlr_last_reading.latitude, awlr_last_reading.longitude],
        12,
      );
      stationMarker.openPopup();
      loadGrafik12Jam(awlr_last_reading.id, 'awlr');
    },
  );
}

function generateOfflineArr(arr_last_reading) {
  var contentStation = loadContentArrLastReading2(arr_last_reading);

  if ($(`#card-station-${arr_last_reading.id}`).length) {
    $(`#card-station-${arr_last_reading.id}`).html(contentStation);
  } else {
    if (arr_last_reading.river_area_id == null) {
      $(`#tab-offline`).append(contentStation);
    } else {
      if ($(`#arr-river-area-${arr_last_reading.river_area_id}`).length == 0) {
        $('#tab-offline')
          .append(`<h4 class="text-center m-0" style="padding: 0.7rem;font-size: 0.8rem;background-color: #2F3567;" id="offline-river-area-${
          arr_last_reading.river_area_id
        }">
                            <span style="color: #CDCED5;">${
                              arr_last_reading.river_area_code == ''
                                ? ''
                                : arr_last_reading.river_area_code + ' : '
                            } </span>
                            <span class="ms-1" style="color: #CDCED5;"> ${
                              arr_last_reading.river_area_name
                            }</span>
                        </h4>
                        <div class="accordion custom-accordion" id="arr-accordion-${
                          arr_last_reading.river_area_id
                        }">
                        </div>`);
      }

      if (
        $(`#aofflinerr-watershed-${arr_last_reading.watershed_id}`).length == 0
      ) {
        $(`#offline-accordion-${arr_last_reading.river_area_id}`)
          .append(`<div class="card mb-0">
                            <div class="card-header card-header-watershed">
                                <h5 class="m-0 position-relative">
                                    <a class="custom-accordion-title d-block d-flex align-items-center"
                                        data-bs-toggle="collapse" href="#offline-watershed-${
                                          arr_last_reading.watershed_id
                                        }"
                                        aria-expanded="true" aria-controls="offline-watershed-${
                                          arr_last_reading.watershed_id
                                        }">
                                        <span style="color: #0ECAF0;font-weight: 600">#${
                                          arr_last_reading.watershed_code == ''
                                            ? ''
                                            : arr_last_reading.watershed_code +
                                              ' : '
                                        } </span>
                                        <span class="ms-1" style="color: #FFC10A;font-weight: 400;">${
                                          arr_last_reading.watershed_name
                                        }</span>
                                        <i class="mdi mdi-chevron-down accordion-arrow" style="color: #D0D1D8;"></i>
                                    </a>
                                </h5>
                            </div>

                            <div id="offline-watershed-${
                              arr_last_reading.watershed_id
                            }" class="collapse show">
                                <div class="card-body content-watershed" style="border-bottom: 1px solid #293067;padding: 0;">

                                </div>
                            </div>
                        </div>`);
      }

      $(
        `#offline-watershed-${arr_last_reading.watershed_id} .content-watershed`,
      ).append(contentStation);
    }
  }

  var intensity = 'arr-icon-offline.png';
  var blinking_class = '';

  if (arr_last_reading.latitude != null && arr_last_reading.longitude != null) {
    var customIcon = L.divIcon({
      iconSize: new L.Point(40, 20),
      iconAnchor: new L.Point(20, 20),
      html: `<div class="ts-marker-wrapper"><a href="javascript:void(0)" class="ts-marker ts-arr" data-ts-id="64" data-ts-ln="60" style="outline: none;"><div class="ts-marker__title">${arr_last_reading.name}</div><image class="${blinking_class}" src="${appendImageVersion(`/images/arr/${intensity}`)}" height="26" /></a></div>`,
    });

    var stationMarker = L.marker(
      [arr_last_reading.latitude, arr_last_reading.longitude],
      {
        icon: customIcon,
      },
    )
      .bindPopup(createDetailPanelStation2(arr_last_reading))
      .addTo(arr_marker);
  }

  // Add a custom attribute to the marker to associate it with the corresponding div
  stationMarker.options.id = arr_last_reading.id;

  // Add a click event listener to the corresponding div
  $('.card-station-offline[data-ts-id="' + arr_last_reading.id + '"]').on(
    'click',
    function () {
      map.setView([arr_last_reading.latitude, arr_last_reading.longitude], 12);
      stationMarker.openPopup();
      loadGrafik12Jam(arr_last_reading.id, 'arr');
    },
  );
}

function loadOfflinePos() {
  $('#tab-offline').empty();
  $('#tab-offline').html(loadShimmerLastReading);

  getData(`/Home/GetListOfflinePos`).then((res) => {
    $('#tab-offline').empty();
    let result = res.data;
    if (result.metaData.code == 200) {
      $('#total-offline').html(result.response.length);
      $.each(result.response, function (key, offline_pos) {
        if (offline_pos.type == 'AWLR') {
          generateOfflineAwlr(offline_pos);
        }

        if (offline_pos.type == 'ARR') {
          generateOfflineArr(offline_pos);
        }
      });
    }
  });
}

//function loadAwlrLastReading2() {
//  $("#tab-awlr").empty();
//  $("#tab-awlr").html(loadShimmerLastReading);
//  getData(`/Home/GetAwlrLastReading`)
//    .then((res) => {
//      $("#tab-awlr").empty();
//      let result = res.data;
//      if (result.metaData.code == 200) {
//        $("#total-awlr").html(result.response.length);

//        if (result.response.length == 0) {
//          $("#tab-awlr").append(
//            `<div class="text-center text-muted">Semua Pos Offline</div>`
//          );
//          $("#running-text-awlr").append("Semua Pos AWLR Offline");
//        } else {
//          // Hitung jumlah pos per watershed
//          const watershedCounts = {};
//          result.response.forEach((item) => {
//            if (item.watershed_id) {
//              watershedCounts[item.watershed_id] =
//                (watershedCounts[item.watershed_id] || 0) + 1;
//            }
//          });

//          $.each(result.response, function (key, awlr_last_reading) {
//            var contentStation = loadContentAwlrLastReading2(awlr_last_reading);
//            var awlrIcon = "siaga_4.png";
//            if ($(`#card-station-${awlr_last_reading.id}`).length) {
//              $(`#card-station-${awlr_last_reading.id}`).html(contentStation);
//            } else {
//              if (awlr_last_reading.id == null) {
//                $(`#tab-awlr`).append(contentStation);
//              } else {
//                if (
//                  $(`#awlr-river-area-${awlr_last_reading.river_area_id}`)
//                    .length == 0
//                ) {
//                  $("#tab-awlr")
//                    .append(`<h4 class="text-center m-0" style="padding: 0.7rem;font-size: 0.8rem;background-color: #2F3567;" id="awlr-river-area-${
//                    awlr_last_reading.river_area_id
//                  }">
//                                        <span style="color: #CDCED5;">${
//                                          awlr_last_reading.river_area_code ==
//                                          ""
//                                            ? ""
//                                            : awlr_last_reading.river_area_code +
//                                              " : "
//                                        } </span>
//                                        <span class="ms-1" style="color: #CDCED5;"> ${
//                                          awlr_last_reading.river_area_name
//                                        }</span>
//                                    </h4>
//                                    <div class="accordion custom-accordion" id="awlr-accordion-${
//                                      awlr_last_reading.river_area_id
//                                    }">
//                                    </div>`);
//                }

//                if (
//                  $(`#awlr-watershed-${awlr_last_reading.watershed_id}`)
//                    .length == 0
//                ) {
//                  const itemCount =
//                    watershedCounts[awlr_last_reading.watershed_id] || 0;
//                  $(`#awlr-accordion-${awlr_last_reading.river_area_id}`)
//                    .append(`
//                    <div class="card mb-0">
//                        <div class="card-header card-header-watershed">
//                            <h5 class="m-0 position-relative">
//                                <a class="custom-accordion-title d-block d-flex align-items-center"
//                                  data-bs-toggle="collapse"
//                                  href="#awlr-watershed-${
//                                    awlr_last_reading.watershed_id
//                                  }"
//                                  aria-expanded="true"
//                                  aria-controls="awlr-watershed-${
//                                    awlr_last_reading.watershed_id
//                                  }">

//                                    <span style="color:#0ECAF0;font-weight:600">
//                                        #${
//                                          awlr_last_reading.watershed_code ===
//                                          ""
//                                            ? ""
//                                            : awlr_last_reading.watershed_code +
//                                              " : "
//                                        }
//                                    </span>

//                                    <span class="ms-1" style="color:#FFC10A;font-weight:400;">
//                                        ${awlr_last_reading.watershed_name}
//                                    </span>

//                                   <span class="ms-auto d-flex align-items-center">
//                                        <span class="badge bg-blue rounded me-1 position-relative">${itemCount}</span>
//                                        <i class="mdi mdi-chevron-down accordion-arrow position-relative" style="color: #D0D1D8;"></i>
//                                    </span>

//                                </a>
//                            </h5>
//                        </div>

//                        <div id="awlr-watershed-${
//                          awlr_last_reading.watershed_id
//                        }" class="collapse show">
//                            <div class="card-body content-watershed"
//                                style="border-bottom:1px solid #293067;padding:0;">
//                            </div>
//                        </div>
//                    </div>
//                    `);

//                }

//                $(
//                  `#awlr-watershed-${awlr_last_reading.watershed_id} .content-watershed`
//                ).append(contentStation);
//              }
//            }

//            // Load Running Text
//            if (awlr_last_reading.water_level != null) {
//              var reading_at = new Date(awlr_last_reading.reading_at);
//              var currentTime = new Date(); // Get the current time
//              var maxDifference = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

//              var timeDifference = parseInt(
//                Math.abs(currentTime.getTime() - reading_at.getTime()) /
//                  (1000 * 60 * 60)
//              ); // Difference in hours

//              if (timeDifference <= 24) {
//                // Your code for when the time difference is 24 hours or less
//                var running_text = getRunningText(awlr_last_reading);

//                if (
//                  awlr_last_reading.warning_status == "3" ||
//                  awlr_last_reading.warning_status == "2" ||
//                  awlr_last_reading.warning_status == "1"
//                ) {
//                  if ($(".running-text-awlr").length) {
//                    $("#running-text-awlr").append(
//                      `<span style="margin: 0 0.5rem;">•</span>`
//                    );
//                  }

//                  $("#running-text-awlr").append(running_text);
//                }
//              } else {
//                // Your code for when the time difference is more than 24 hours
//                console.log("Time difference is more than 24 hours.");
//              }
//            }

//            if (
//              awlr_last_reading.latitude != null &&
//              awlr_last_reading.longitude != null
//            ) {
//              let awlr_level_class = "";

//              switch (awlr_last_reading.warning_status) {
//                case "0":
//                  awlrIcon = "siaga_4.png";
//                  awlr_level_class = "";
//                  break;
//                case "3":
//                  awlrIcon = "siaga_3.png";
//                  awlr_level_class = "alert-siaga3";
//                  break;
//                case "2":
//                  awlrIcon = "siaga_2.png";
//                  awlr_level_class = "alert-siaga2";
//                  break;
//                case "1":
//                  awlrIcon = "siaga_1.png";
//                  awlr_level_class = "alert-siaga1";
//                  break;
//                default:
//                  awlr_level_class = "";
//                  awlrIcon = "siaga_4.png";
//                  break;
//              }

//              var customIcon = L.divIcon({
//                iconSize: new L.Point(40, 20),
//                iconAnchor: new L.Point(20, 20),
//                html: `<div class="ts-marker-wrapper"><a href="javascript:void(0)" class="ts-marker ts-arr" data-ts-id="64" data-ts-ln="60" style="outline: none;"><div class="ts-marker__title">${awlr_last_reading.name}</div><image class="${awlr_level_class}" src="/images/awlr/${awlrIcon}" height="28" /></a></div>`,
//              });

//              var stationMarker = L.marker(
//                [awlr_last_reading.latitude, awlr_last_reading.longitude],
//                {
//                  icon: customIcon,
//                }
//              )
//                .bindPopup(createDetailPanelStation2(awlr_last_reading))
//                .addTo(awlr_marker);
//            }

//            // Add a custom attribute to the marker to associate it with the corresponding div
//            stationMarker.options.id = awlr_last_reading.id;

//            // Add a click event listener to the corresponding div
//            //$(
//            //  '.card-station-awlr[data-ts-id="' + awlr_last_reading.id + '"]'
//            //).on("click", function () {

//            //  map.setView([awlr_last_reading.latitude, awlr_last_reading.longitude], 12);
//            //  stationMarker.openPopup();
//            //  loadGrafik12Jam(awlr_last_reading.id, 'awlr');
//              //});

//              $('.card-station-awlr[data-ts-id="' + awlr_last_reading.id + '"]').on("click", function () {
//                  const latlng = [awlr_last_reading.latitude, awlr_last_reading.longitude];

//                  // Pindahkan view peta
//                  map.setView(latlng, 12);

//                  // Munculkan popup langsung di koordinat tersebut
//                  L.popup()
//                      .setLatLng(latlng)
//                      .setContent(stationMarker.getPopup().getContent()) // Mengambil konten dari popup marker yang sudah ada
//                      .openOn(map);

//                  loadGrafik12Jam(awlr_last_reading.id, 'awlr');
//              });

//          });
//        }
//      }
//    })
//    .catch((err) => {
//      console.log(err);
//      console.log(err.response);
//    });
//}

async function loadAwlrLastReading2() {
  const $container = $('#tab-awlr');
  const $runningText = $('#running-text-awlr');
  const $totalAwlr = $('#total-awlr');

  // 1. Reset State & Loading
  $container.empty().html(loadShimmerLastReading);
  $runningText.empty();

  try {
    const res = await getData(`/Home/GetAwlrLastReading`);
    const result = res.data;

    if (result.metaData.code !== 200) return;

    $container.empty();
    const data = result.response || [];
    $totalAwlr.html(data.length);

    // 2. Handling Data Kosong
    if (data.length === 0) {
      $container.append(
        `<div class="text-center text-muted p-3">Semua Pos Offline</div>`,
      );
      $runningText.append('Semua Pos AWLR Offline');
      return;
    }

    // 3. Hitung jumlah pos per watershed (Hanya jika ID valid)
    const watershedCounts = {};
    data.forEach((item) => {
      if (item.watershed_id) {
        watershedCounts[item.watershed_id] =
          (watershedCounts[item.watershed_id] || 0) + 1;
      }
    });

    // 4. Looping Utama
    $.each(data, function (key, awlr) {
      const contentStation = loadContentAwlrLastReading2(awlr);

      // Validasi: Cek apakah data wilayah dan DAS tersedia
      const hasRiverArea =
        awlr.river_area_id !== null &&
        awlr.river_area_id !== undefined &&
        awlr.river_area_id !== '';
      const hasWatershed =
        awlr.watershed_id !== null &&
        awlr.watershed_id !== undefined &&
        awlr.watershed_id !== '';

      // --- A. RENDER UI LIST ---
      if (!hasRiverArea || !hasWatershed) {
        // Jika ID null, langsung tempel stasiun ke container utama tanpa bungkus
        $container.append(contentStation);
      } else {
        // Buat Header River Area jika belum ada
        if ($(`#awlr-river-area-${awlr.river_area_id}`).length === 0) {
          const riverCode = awlr.river_area_code
            ? `${awlr.river_area_code} : `
            : '';
          $container.append(`
                        <h4 class="text-center m-0" style="padding: 0.7rem; font-size: 0.8rem; background-color: #2F3567;" id="awlr-river-area-${awlr.river_area_id}">
                            <span style="color: #CDCED5;">${riverCode}${awlr.river_area_name}</span>
                        </h4>
                        <div class="accordion custom-accordion" id="awlr-accordion-${awlr.river_area_id}"></div>
                    `);
        }

        // Buat Accordion Watershed jika belum ada
        if ($(`#awlr-watershed-${awlr.watershed_id}`).length === 0) {
          const wsCode = awlr.watershed_code ? `${awlr.watershed_code} : ` : '';
          const count = watershedCounts[awlr.watershed_id] || 0;
          $(`#awlr-accordion-${awlr.river_area_id}`).append(`
                        <div class="card mb-0">
                            <div class="card-header card-header-watershed">
                                <h5 class="m-0 position-relative">
                                    <a class="custom-accordion-title d-block d-flex align-items-center"
                                       data-bs-toggle="collapse"
                                       href="#awlr-watershed-${awlr.watershed_id}">

                                        <span style="color:#0ECAF0;font-weight:600">
                                            #${awlr.watershed_code === '' ? '' : awlr.watershed_code + ' : '}
                                        </span>
                                        <span class="ms-1" style="color:#FFC10A;font-weight:400;">
                                            ${awlr.watershed_name}
                                        </span>

                                        <span class="ms-auto d-flex align-items-center">
                                            <span class="badge bg-blue rounded me-2 position-relative">${count}</span>
                                            <i class="mdi mdi-chevron-down accordion-arrow position-relative" style="color: #D0D1D8;"></i>
                                        </span>

                                    </a>
                                </h5>
                            </div>
                            <div id="awlr-watershed-${awlr.watershed_id}" class="collapse show">
                                <div class="card-body content-watershed" style="border-bottom:1px solid #293067; padding:0;"></div>
                            </div>
                        </div>
                    `);
        }
        // Masukkan stasiun ke dalam watershed body
        $(`#awlr-watershed-${awlr.watershed_id} .content-watershed`).append(
          contentStation,
        );
      }

      // --- B. LOGIKA RUNNING TEXT ---
      if (awlr.water_level != null && awlr.reading_at != null) {
        const readingAt = new Date(awlr.reading_at);
        const timeDiff = Math.abs(new Date() - readingAt) / 36e5; // jam

        if (
          timeDiff <= 24 &&
          ['1', '2', '3'].includes(String(awlr.warning_status))
        ) {
          if ($runningText.children().length > 0) {
            $runningText.append(`<span style="margin: 0 0.5rem;">•</span>`);
          }
          $runningText.append(getRunningText(awlr));
        }
      }

      // --- C. LOGIKA MARKER PETA ---
      if (awlr.latitude != null && awlr.longitude != null) {
        const iconMap = {
          1: 'siaga_1.png',
          2: 'siaga_2.png',
          3: 'siaga_3.png',
        };
        const classMap = {
          1: 'alert-siaga1',
          2: 'alert-siaga2',
          3: 'alert-siaga3',
        };

        const awlrIcon = iconMap[awlr.warning_status] || 'siaga_4.png';
        const awlrLevelClass = classMap[awlr.warning_status] || '';

        const customIcon = L.divIcon({
          iconSize: [40, 20],
          iconAnchor: [20, 20],
          html: `<div class="ts-marker-wrapper">
                            <a href="javascript:void(0)" class="ts-marker ts-arr">
                                <div class="ts-marker__title">${awlr.name}</div>
                                <img class="${awlrLevelClass}" src="${appendImageVersion(`/images/awlr/${awlrIcon}`)}" height="28" />
                            </a>
                           </div>`,
        });

        const stationMarker = L.marker([awlr.latitude, awlr.longitude], {
          icon: customIcon,
          warningStatus: awlr.warning_status,
        })
          .bindPopup(createDetailPanelStation2(awlr))
          .addTo(awlr_marker);

        // Event Klik List Card ke Peta
        $(document)
          .off('click', `.card-station-awlr[data-ts-id="${awlr.id}"]`)
          .on(
            'click',
            `.card-station-awlr[data-ts-id="${awlr.id}"]`,
            function () {
              const latlng = [awlr.latitude, awlr.longitude];
              map.setView(latlng, 12);

              L.popup()
                .setLatLng(latlng)
                .setContent(stationMarker.getPopup().getContent())
                .openOn(map);

              loadGrafik12Jam(awlr.id, 'awlr');
            },
          );
      }
    });

    onMarkerLoadComplete();
  } catch (err) {
    console.error('Error loadAwlrLastReading2:', err);
  }
}

function loadContentAwlrLastReading2(awlr_last_reading) {
  // Reading
  //console.log(awlr_last_reading);

  if (awlr_last_reading == null) {
    return '';
  }

  var wl_elevation_operator =
    awlr_last_reading.water_level_elevation > 0 ? '+' : '';
  var change_status = '';
  switch (awlr_last_reading.change_status) {
    case 'increase':
      change_status =
        '<i class="mdi mdi-arrow-up-circle text-danger me-1"></i>';
      break;
    case 'decrease':
      change_status =
        '<i class="mdi mdi-arrow-down-circle text-success me-1"></i>';
      break;
  }

  // Warning Status
  var class_warning_status = '';
  var warning_status =
    '<span class="badge badge-awlr-nostatus rounded-1 ms-1 align-self-center">TANPA STATUS</span>';
  switch (awlr_last_reading.warning_status) {
    case '0':
      warning_status =
        '<span class="badge badge-awlr-normal rounded-1 ms-1 align-self-center">NORMAL</span>';
      class_warning_status = 'normal';
      break;
    case '3':
      warning_status =
        '<span class="badge badge-awlr-siaga3 rounded-1 ms-1 align-self-center blinking-content">WASPADA</span>';
      class_warning_status = 'siaga3';
      break;
    case '2':
      warning_status =
        '<span class="badge badge-awlr-siaga2 rounded-1 ms-1 align-self-center blinking-content">SIAGA</span>';
      class_warning_status = 'siaga2';
      break;
    case '3':
      warning_status =
        '<span class="badge badge-awlr-siaga1 rounded-1 ms-1 align-self-center blinking-content">AWAS</span>';
      class_warning_status = 'siaga1';
      break;
  }

  var water_level =
    awlr_last_reading.water_level != null
      ? `<h4 class="text-status-${class_warning_status}">${change_status} ${awlr_last_reading.water_level.toFixed(2)} <sup>${awlr_last_reading.unit_display}</sup></h4>`
      : '-';
  var water_level_elevation =
    awlr_last_reading.water_level_elevation != null
      ? `${wl_elevation_operator}${awlr_last_reading.water_level_elevation} <sup>mdpl</sup>`
      : '-';
  var debit =
    awlr_last_reading.debit != null
      ? `${awlr_last_reading.debit} <sup>m<sup>3</sup>/s</sup>`
      : '-';

  // Device
  var device_status = `<small class="mdi mdi-circle text-danger"></small> Offline `;
  if (awlr_last_reading.status == 'online') {
    device_status = `<small class="mdi mdi-circle text-success"></small> Online `;
  }

  // Location

  // Level Warning
  var warning_status_bar = '';
  if (
    awlr_last_reading.siaga1 != null &&
    awlr_last_reading.siaga2 != null &&
    awlr_last_reading.siaga3 != null
  ) {
    warning_status_bar = `
                    <div class="progress-meter mt-2 mb-2">
                        <div class="meter meter-normal meter-left" style="width: 25%;" title="Normal <br> < 6 m"><span class="fw-normal meter-text" style="color: #12cdfc;">0</span></div>
                        <div class="meter meter-waspada meter-left" style="width: 25%;" title="Siaga 3 <br> ${awlr_last_reading.siaga3} ${awlr_last_reading.unit_display} - ${awlr_last_reading.siaga2} ${awlr_last_reading.unit_display}"><span class="fw-normal meter-text" style="color: #09FE02;">${awlr_last_reading.siaga3} ${awlr_last_reading.unit_display}</span></div>
                        <div class="meter meter-siaga meter-left" style="width: 25%;" title="Siaga 2 <br> ${awlr_last_reading.siaga2} ${awlr_last_reading.unit_display} - ${awlr_last_reading.siaga1} ${awlr_last_reading.unit_display}"><span class="fw-normal meter-text" style="color: #FDFE01;">${awlr_last_reading.siaga2} ${awlr_last_reading.unit_display}</span></div>
                        <div class="meter meter-awas meter-left" style="width: 25%;" title="Siaga 1 <br> > ${awlr_last_reading.siaga1} ${awlr_last_reading.unit_display}"><span class="fw-normal meter-text" style="color: #F40A07;">${awlr_last_reading.siaga1} ${awlr_last_reading.unit_display}</span></div>
                    </div>
                `;
  }

  var battery = '';

  if (awlr_last_reading.battery != null) {
    if (awlr_last_reading.battery < 7) {
      battery = `<span><i class="mdi mdi-battery-charging-low ms-1" style="color: #F69696;"></i> ${awlr_last_reading.battery} Volt</span>`;
    } else {
      battery = `<span><i class="mdi mdi-battery-charging-high ms-1" style="color: #F69696;"></i> ${awlr_last_reading.battery} Volt</span>`;
    }
  }

  var card_header = null;

  if (awlr_last_reading.reading_at != null) {
    const currentDate = moment().format('YYYY-MMM-DD');
    var reading_at = '';

    if (
      moment(awlr_last_reading.reading_at).format('YYYY-MMM-DD') == currentDate
    ) {
      reading_at = `Hari Ini <span class="text-muted">${moment(awlr_last_reading.reading_at).format('HH:mm')}</span>`;
    } else {
      reading_at = moment(awlr_last_reading.reading_at)
        .locale('id')
        .format('D MMMM YYYY HH:mm');
    }

    card_header = `
                    <div class="card-header">
                        <div class="d-flex align-items-center">
                            <span class="reading-at">${device_status}</span>
                            <span class="reading-at ms-auto">${reading_at} WIB</span>
                        </div>
                    </div>
                `;
  }

  var card_footer = null;

  if (awlr_last_reading.status == 'offline') {
    if (awlr_last_reading.reading_at == null) {
      card_footer = `<div class="card-footer">
                        <small class="m-0 d-flex align-items-center text-warning fw-normal" style="color: #ED8F2A;">
                            <i class="mdi mdi-alert-circle-outline font-14 me-1"></i>
                            Alat belum aktif
                        </small>
                    </div>`;
    } else {
      card_footer = `<div class="card-footer">
                        <small class="m-0 d-flex align-items-center text-warning fw-normal" style="color: #ED8F2A;">
                            <i class="mdi mdi-alert-circle-outline font-14 me-1"></i>
                            Alat tidak aktif lebih dari 24 jam
                        </small>
                    </div>`;
    }
  }

  return `
                <div class="card-station-awlr" data-ts-id="${awlr_last_reading.id}" id="card-station-${awlr_last_reading.id}" data-last-update="${awlr_last_reading.reading_at == null ? '' : moment(awlr_last_reading.reading_at).locale('id').format('YYYY-MM-DD HH:mm:ss')}">
                    <div class="card card-station ">
                        ${card_header != null ? card_header : ''}
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <div class="w-100">
                                    <h4 class="card-title text-station-name m-0 align-self-center">${awlr_last_reading.name}</h4>
                                </div>
                                ${warning_status}
                            </div>

                            <div class="reading-device d-flex align-items-center mb-1">
                                    <span><i class="fe-hard-drive"></i> ${awlr_last_reading.brand_name}</span>
                                    <span class="badge badge-outline-secondary rounded-1 ms-1" style="color: #A9ABB8;border-color: #A9ABB8;">${awlr_last_reading.device_id}</span>
                                    ${battery}
                            </div>

                            <div class="d-flex justify-content-around align-items-center reading-text">
                                <div class="col-4 text-center">
                                    ${water_level}
                                </div>
                                <div class="col-4 text-center">
                                    <h4>${water_level_elevation}</h4>
                                </div>
                                <div class="col-4 text-center">
                                    <h4>${debit}</h4>
                                </div>
                            </div>
                            <div class="d-flex justify-content-around reading-text">
                                <div class="col-4 text-center">
                                    Tinggi Muka Air
                                </div>
                                <div class="col-4 text-center">
                                    Elevasi Muka Air
                                </div>
                                <div class="col-4 text-center">
                                    Debit
                                </div>
                            </div>
                            ${warning_status_bar}
                        </div>
                        ${card_footer != null ? card_footer : ''}
                    </div>
                </div>
            `;
}

function createDetailPanelStation2(reading) {
  // 1. Handle Foto & Nama
  var photo = '/images/default-pu.png';
  if (reading.photo != null && reading.photo !== '') {
    photo = `/uploads/images/stations/${reading.photo}`;
  }
  var stationName = reading.name || '-';

  // 2. Handle Status Device
  var device_status =
    '<small class="mdi mdi-circle text-danger"></small> Offline';
  if (reading.status == 'online') {
    device_status =
      '<small class="mdi mdi-circle text-success"></small> Online';
  }

  var panelContent = '<table class="table mb-2 font-12"><tbody>';

  // Row Nama & Status
  panelContent += `<tr>
        <td class="px-0 py-2" colspan="3">
            <div class="d-flex align-items-start">
          <img class="me-2 rounded-3" src="${appendImageVersion(photo)}" width="35" height="35" alt="${stationName}">
                <div class="w-100">
                    <h5 class="mt-0 mb-1 fw-semibold font-12">${stationName}</h5>
                    ${device_status}
                </div>
            </div>
        </td>
    </tr>`;

  // Row Logger
  panelContent += `<tr>
        <td class="py-1 px-0">Logger</td>
        <td class="py-1 px-2">:</td>
        <td class="py-1 px-0 align-middle">
            ${
              reading.brand_name || '-'
            } <span class="badge badge-outline-secondary rounded-1">${
              reading.device_id || '-'
            }</span>
        </td>
    </tr>`;

  // Row Koordinat
  var lat = reading.latitude || '-';
  var lon = reading.longitude || '-';
  panelContent += `<tr>
        <td class="py-1 px-0">Koordinat</td>
        <td class="py-1 px-2">:</td>
        <td class="py-1 px-0 align-middle">${lat}, ${lon}</td>
    </tr>`;

  // 3. Handle Data Pembacaan (Jika data waktu tersedia)
  if (reading.reading_at != null) {
    panelContent += `<tr>
            <td class="py-1 px-0">Waktu</td>
            <td class="py-1 px-2">:</td>
            <td class="py-1 px-0">${moment(reading.reading_at)
              .locale('id')
              .format('D MMMM YYYY HH:mm')} WIB</td>
        </tr>`;

    if (reading.type == 'AWLR') {
      // Safety toFixed untuk AWLR
      var wl =
        reading.water_level != null
          ? `${reading.water_level.toFixed(2)} <sup>${
              reading.unit_display || 'm'
            }</sup>`
          : '-';
      var wle =
        reading.water_level_elevation != null
          ? `${reading.water_level_elevation.toFixed(2)} <sup>Mdpl</sup>`
          : '-';
      var deb =
        reading.debit != null ? `${reading.debit} <sup>m3/s</sup>` : '-';

      panelContent += `<tr><td class="py-1 px-0 nowrap">Tinggi Muka Air</td><td class="py-1 px-2">:</td><td class="py-1 px-0 fw-semibold">${wl}</td></tr>`;
      panelContent += `<tr><td class="py-1 px-0 nowrap">Elevasi Muka Air</td><td class="py-1 px-2">:</td><td class="py-1 px-0 fw-semibold">${wle}</td></tr>`;
      panelContent += `<tr><td class="py-1 px-0 nowrap">Debit</td><td class="py-1 px-2">:</td><td class="py-1 px-0 fw-semibold">${deb}</td></tr>`;
      panelContent += `<tr><td class="py-1 px-0 nowrap">Status</td><td class="py-1 px-2">:</td><td class="py-1 px-0 fw-semibold">${
        getAwlrWarningStatus(reading.warning_status) ?? '-'
      }</td></tr>`;
    } else if (reading.type == 'ARR') {
      // Safety toFixed untuk ARR
      var rain =
        reading.rainfall != null
          ? `${reading.rainfall.toFixed(2)} <sup>mm</sup>`
          : '-';
      var rainMax =
        reading.rainfall_last_hour != null
          ? `${reading.rainfall_last_hour.toFixed(2)} <sup>mm</sup>`
          : '-';

      panelContent += `<tr><td class="py-1 px-0 nowrap">Curah Hujan</td><td class="py-1 px-2">:</td><td class="py-1 px-0 fw-semibold">${rain}</td></tr>`;
      panelContent += `<tr><td class="py-1 px-0 nowrap">CH 1 Jam</td><td class="py-1 px-2">:</td><td class="py-1 px-0 fw-semibold">${rainMax}</td></tr>`;
      panelContent += `<tr><td class="py-1 px-0 nowrap">Intensitas</td><td class="py-1 px-2">:</td><td class="py-1 px-0 fw-semibold">${normalizeIntensityStatus(reading.intensity_last_hour)}</td></tr>`;
    }
  } else {
    // Fallback jika reading_at NULL
    panelContent += `<tr><td colspan="3" class="text-center text-muted py-2 fst-italic">Belum ada data pembacaan</td></tr>`;
  }

  panelContent += '</tbody></table>';

  // Row Button Detail
  panelContent += `<a href="/StationDetail/Index?id=${reading.id}" target="_blank" class="btn btn-sm btn-primary rounded-pill waves-effect waves-light text-white w-100">Lihat Detail</a>`;

  return panelContent;
}

function getAwlrWarningStatus(warning_status) {
  if (warning_status == null) return 'Tanpa Status';
  if (warning_status == '') return 'Tanpa Status';

  switch (warning_status) {
    case '0':
      return 'Normal';
    case '1':
      return 'Awas';
    case '2':
      return 'Siaga';
    case '3':
      return 'Waspada';
    default:
      return '-';
  }
}

function getIconMarkerArr(value) {
  console.log(value);

  if (value === null || value === 0) {
    // Tidak ada hujan atau offline
    return '/images/arr/berawan-siang-outline.png';
    //return '/images/arr/tidak-hujan.svg';
  } else if (value <= 5) {
    // Ringan (1-5 mm/jam)
    return '/images/arr/hujan-ringan.png';
    //return '/images/arr/ringan.svg';
  } else if (value <= 10) {
    // Sedang (5-10 mm/jam)
    return '/images/arr/hujan-sedang.png';
    //return '/images/arr/sedang.svg';
  } else if (value <= 20) {
    // Lebat (10-20 mm/jam)
    return '/images/arr/hujan-lebat.png';
    //return '/images/arr/lebat.svg';
  } else if (value <= 100) {
    // Sangat Lebat (>20 mm/jam)
    return '/images/arr/hujan-sangat-lebat.png';
    //return '/images/arr/sangat-lebat.svg';
  } else if (value > 100) {
    // Ekstrem (>100 mm/jam)
    return '/images/arr/hujan-ekstrem.png';
    //return '/images/arr/ekstrem.svg';
  } else {
    return '/images/arr/berawan-siang-outline.png';
    //return '/images/arr/tidak-hujan.svg';
  }
}

function getIconMarkerArr2(value) {
  console.log(value);

  if (value === null || value === 0) {
    // Tidak ada hujan atau offline
    return '/images/arr/berawan-siang-outline.png';
    //return '/images/arr/tidak-hujan.svg';
  } else if (value <= 5) {
    // Ringan (1-5 mm/jam)
    return '/images/arr/hujan-ringan.png';
    //return '/images/arr/ringan.svg';
  } else if (value <= 10) {
    // Sedang (5-10 mm/jam)
    return '/images/arr/hujan-sedang.png';
    //return '/images/arr/sedang.svg';
  } else if (value <= 20) {
    // Lebat (10-20 mm/jam)
    return '/images/arr/hujan-lebat.png';
    //return '/images/arr/lebat.svg';
  } else if (value <= 100) {
    // Sangat Lebat (>20 mm/jam)
    return '/images/arr/hujan-sangat-lebat.png';
    //return '/images/arr/sangat-lebat.svg';
  } else if (value > 100) {
    // Ekstrem (>100 mm/jam)
    return '/images/arr/hujan-ekstrem.png';
    //return '/images/arr/ekstrem.svg';
  } else {
    return '/images/arr/berawan-siang-outline.png';
    //return '/images/arr/tidak-hujan.svg';
  }
}

function loadArrLastReading2() {
  $('#tab-arr').empty();
  $('#tab-arr').html(loadShimmerLastReading);
  getData(`/Home/GetArrLastReading`)
    .then((res) => {
      $('#tab-arr').empty();
      let result = res.data;

      if (result.metaData.code == 200) {
        $('#total-arr').html(result.response.length);

        if (result.response.length == 0) {
          $('#tab-arr').append(
            `<div class="text-center text-muted">Semua Pos Offline</div>`,
          );
          $('#running-text-arr').append(' | Semua Pos ARR Offline');
        } else {
          // Hitung jumlah pos per watershed
          const watershedCounts = {};
          result.response.forEach((item) => {
            if (item.watershed_id) {
              watershedCounts[item.watershed_id] =
                (watershedCounts[item.watershed_id] || 0) + 1;
            }
          });

          $.each(result.response, function (key, arr_last_reading) {
            var contentStation = loadContentArrLastReading2(arr_last_reading);

            if ($(`#card-station-${arr_last_reading.id}`).length) {
              $(`#card-station-${arr_last_reading.id}`).html(contentStation);
            } else {
              if (arr_last_reading.river_area_id == null) {
                $(`#tab-arr`).append(contentStation);
              } else {
                if (
                  $(`#arr-river-area-${arr_last_reading.river_area_id}`)
                    .length == 0
                ) {
                  $('#tab-arr')
                    .append(`<h4 class="text-center m-0" style="padding: 0.7rem;font-size: 0.8rem;background-color: #2F3567;" id="arr-river-area-${arr_last_reading.river_area_id}">
                                        <span style="color: #CDCED5;">${arr_last_reading.river_area_code == '' ? '' : arr_last_reading.river_area_code + ' : '} </span>
                                        <span class="ms-1" style="color: #CDCED5;"> ${arr_last_reading.river_area_name}</span>
                                    </h4>
                                    <div class="accordion custom-accordion" id="arr-accordion-${arr_last_reading.river_area_id}">
                                    </div>`);
                }

                if (
                  $(`#arr-watershed-${arr_last_reading.watershed_id}`).length ==
                  0
                ) {
                  const itemCount =
                    watershedCounts[arr_last_reading.watershed_id] || 0;
                  $(`#arr-accordion-${arr_last_reading.river_area_id}`)
                    .append(`<div class="card mb-0">
                                        <div class="card-header card-header-watershed">
                                            <h5 class="m-0 position-relative">
                                                <a class="custom-accordion-title d-block d-flex align-items-center"
                                                    data-bs-toggle="collapse" href="#arr-watershed-${arr_last_reading.watershed_id}"
                                                    aria-expanded="true" aria-controls="arr-watershed-${arr_last_reading.watershed_id}">
                                                    <span style="color: #0ECAF0;font-weight: 600">#${arr_last_reading.watershed_code == '' ? '' : arr_last_reading.watershed_code + ' : '} </span>
                                                    <span class="ms-1" style="color: #FFC10A;font-weight: 400;">${arr_last_reading.watershed_name}</span>
                                                    <span class="ms-auto d-flex align-items-center">
                                                        <span class="badge bg-success rounded me-1 position-relative">${itemCount}</span>
                                                        <i class="mdi mdi-chevron-down accordion-arrow position-relative" style="color: #D0D1D8;"></i>
                                                    </span>

                                                </a>
                                            </h5>
                                        </div>

                                        <div id="arr-watershed-${arr_last_reading.watershed_id}" class="collapse show">
                                            <div class="card-body content-watershed" style="border-bottom: 1px solid #293067;padding: 0;">

                                            </div>
                                        </div>
                                    </div>`);
                }

                $(
                  `#arr-watershed-${arr_last_reading.watershed_id} .content-watershed`,
                ).append(contentStation);
              }
            }

            // Load Running Text
            if (arr_last_reading.rainfall_last_hour != null) {
              var reading_at = new Date(arr_last_reading.reading_at);
              var currentTime = new Date(); // Get the current time
              var maxDifference = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

              // Calculate the time difference in milliseconds
              var timeDifference = parseInt(
                Math.abs(currentTime.getTime() - reading_at.getTime()) /
                  (1000 * 60 * 60),
              ); // Difference in hours

              // Check if the difference is within 24 hours
              if (timeDifference <= 24) {
                var running_text = getRunningText(arr_last_reading);

                if (arr_last_reading.rainfall_last_hour > 20) {
                  // Check if the element already has content before adding a separator
                  if ($('#running-text-arr').children().length > 0) {
                    $('#running-text-arr').append(
                      `<span style="margin: 0 0.5rem;">•</span>`,
                    );
                  }

                  $('#running-text-arr').append(running_text);
                }
              } else {
                // This block will run if the last reading is more than 24 hours old
                console.log('Last reading is more than 24 hours old.');
              }
            }

            var intensity = 'arr-icon-offline.png';
            var blinking_class = '';

            if (arr_last_reading.status == 'online') {
              intensity = getIntensityIcon(
                arr_last_reading.intensity_last_hour,
              );
              if (
                arr_last_reading.intensity_last_hour != 'Cerah' &&
                arr_last_reading.intensity_last_hour != 'Tidak Hujan' &&
                arr_last_reading.intensity_last_hour != 'Berawan'
              ) {
                blinking_class = 'blinking-content';
              }
            }

            if (
              arr_last_reading.latitude != null &&
              arr_last_reading.longitude != null
            ) {
              var customIcon = L.divIcon({
                iconSize: new L.Point(40, 20),
                iconAnchor: new L.Point(20, 20),
                html: `<div class="ts-marker-wrapper"><a href="javascript:void(0)" class="ts-marker ts-arr" data-ts-id="64" data-ts-ln="60" style="outline: none;"><div class="ts-marker__title">${arr_last_reading.name}</div><image class="${blinking_class}" src="${appendImageVersion(getIconMarkerArr(arr_last_reading.rainfall_last_hour))}" height="26" /></a></div>`,
              });

              var stationMarker = L.marker(
                [arr_last_reading.latitude, arr_last_reading.longitude],
                {
                  icon: customIcon,
                  intensityStatus: normalizeIntensityStatus(
                    arr_last_reading.intensity_last_hour,
                  ),
                },
              )
                .bindPopup(createDetailPanelStation2(arr_last_reading))
                .addTo(arr_marker);
            }

            // Add a custom attribute to the marker to associate it with the corresponding div
            stationMarker.options.id = arr_last_reading.id;

            $('.card-station-arr[data-ts-id="' + arr_last_reading.id + '"]').on(
              'click',
              function () {
                const latlng = [
                  arr_last_reading.latitude,
                  arr_last_reading.longitude,
                ];

                // Pindahkan view peta
                map.setView(latlng, 12);

                // Munculkan popup langsung di koordinat tersebut
                L.popup()
                  .setLatLng(latlng)
                  .setContent(stationMarker.getPopup().getContent()) // Mengambil konten dari popup marker yang sudah ada
                  .openOn(map);

                loadGrafik12Jam(arr_last_reading.id, 'arr');
              },
            );
          });
        }
      }

      onMarkerLoadComplete();
    })
    .catch((err) => {
      console.log(err);
      console.log(err.response);
    });
}

function loadContentArrLastReading2(arr_last_reading) {
  // 1. Handle Status Device (Pastikan status tidak null)
  var status = (arr_last_reading.status || 'offline').toLowerCase();
  var device_status = `<small class="mdi mdi-circle text-danger"></small> Offline `;
  if (status === 'online') {
    device_status = `<small class="mdi mdi-circle text-success"></small> Online `;
  }

  // 2. Intensitas Per Jam (Handle null pada rainfall_last_hour dan intensity_last_hour)
  var intensity_per_hour = ``;
  var blinking_class = '';

  // Safety check untuk intensitas
  var intensityText = normalizeIntensityStatus(
    arr_last_reading.intensity_last_hour || 'Cerah',
  );
  var rainfallValue = arr_last_reading.rainfall_last_hour;

  if (
    intensityText !== 'Cerah' &&
    intensityText !== 'Tidak Hujan' &&
    intensityText != 'Berawan'
  ) {
    blinking_class = 'blinking-content';
  }

  // Hanya tampilkan jika data pembacaan tersedia
  if (rainfallValue !== null && arr_last_reading.reading_at !== null) {
    intensity_per_hour = `
              <h4 class="text-center mt-2 fw-normal" style="font-size: 0.7rem;">Intensitas 1 Jam Terakhir :</h4>
              <div class="d-flex justify-content-around align-items-center reading-text mb-1">
                  <div class="col-4 text-center">
                      <h4 class="text-range-hour">${moment(
                        arr_last_reading.reading_at,
                      ).format('HH:mm')}</h4>
                  </div>
                  <div class="col-4 text-center">
                      <h4>${rainfallValue.toFixed(2)} <sup>mm</sup></h4>
                  </div>
                  <div class="col-4 col-intensity text-center">
                      <img class="${blinking_class}" src="${appendImageVersion(
                        `/images/arr/${getIntensityIcon(intensityText)}`,
                      )}" alt="${intensityText}">
                  </div>
              </div>
              <div class="d-flex justify-content-around reading-text">
                  <div class="col-4 text-center">Waktu (WIB)</div>
                  <div class="col-4 text-center">Curah Hujan</div>
                  <div class="col-4 text-center fst-italic">${intensityText}</div>
              </div>`;
  } else {
    intensity_per_hour = `
              <h4 class="text-center mt-2 fw-normal" style="font-size: 0.7rem;">Intensitas 1 Jam Terakhir :</h4>
              <div class="d-flex justify-content-around align-items-center reading-text mb-1">
                  <div class="col-4 text-center">
                      <h4 class="text-range-hour">${moment(
                        arr_last_reading.reading_at,
                      ).format('HH:mm')}</h4>
                  </div>
                  <div class="col-4 text-center">
                      <h4> - </h4>
                  </div>
                  <div class="col-4 col-intensity text-center">
                      <img class="${blinking_class}" src="${appendImageVersion(
                        `/images/arr/${getIntensityIcon(intensityText)}`,
                      )}" alt="${intensityText}">
                  </div>
              </div>
              <div class="d-flex justify-content-around reading-text">
                  <div class="col-4 text-center">Waktu (WIB)</div>
                  <div class="col-4 text-center">Curah Hujan</div>
                  <div class="col-4 text-center fst-italic">${intensityText}</div>
              </div>`;
  }

  // 3. Handle Battery Voltage
  var battery = '';
  if (
    arr_last_reading.battery_voltage !== null &&
    arr_last_reading.battery_voltage !== undefined
  ) {
    var voltValue = arr_last_reading.battery_voltage;
    var batteryIcon =
      voltValue < 10 ? 'mdi-battery-charging-low' : 'mdi-battery-charging-high';
    battery = `<span><small class="mdi ${batteryIcon} ms-1" style="color: #F69696;"></small> ${voltValue} Volt</span>`;
  }

  // 4. Handle Card Header & Reading Time
  var card_header = '';
  if (arr_last_reading.reading_at !== null) {
    const currentDate = moment().format('YYYY-MM-DD');
    const readingDate = moment(arr_last_reading.reading_at).format(
      'YYYY-MM-DD',
    );
    var readingAtLabel =
      readingDate === currentDate
        ? `Hari Ini`
        : moment(arr_last_reading.reading_at)
            .locale('id')
            .format('D MMMM YYYY');

    card_header = `
            <div class="card-header">
                <div class="d-flex align-items-center">
                    <span class="reading-at">${device_status}</span>
                    <span class="reading-at ms-auto">${readingAtLabel}</span>
                </div>
            </div>`;
  }

  // 5. Handle Card Footer (Offline Logic)
  var card_footer = '';
  if (status === 'offline') {
    var footerMsg =
      arr_last_reading.reading_at === null
        ? 'Alat belum aktif'
        : 'Alat tidak aktif lebih dari 24 jam';
    card_footer = `
            <div class="card-footer">
                <small class="m-0 d-flex align-items-center text-warning fw-normal" style="color: #ED8F2A;">
                    <i class="mdi mdi-alert-circle-outline font-14 me-1"></i>
                    ${footerMsg}
                </small>
            </div>`;
  }

  // 6. Return Template
  return `
        <div class="card-station-arr" data-ts-id="${
          arr_last_reading.id
        }" id="card-station-${arr_last_reading.id}" 
             data-last-update="${
               arr_last_reading.reading_at == null
                 ? ''
                 : moment(arr_last_reading.reading_at)
                     .locale('id')
                     .format('YYYY-MM-DD HH:mm:ss')
             }">
            <div class="card card-station">
                ${card_header}
                <div class="card-body">
                    <div class="w-100">
                        <h4 class="card-title text-station-name m-0 mb-2">${
                          arr_last_reading.name || 'Unknown Station'
                        }</h4>
                    </div>
                    <div class="reading-device d-flex align-items-center mb-1">
                        <span><i class="fe-hard-drive"></i> ${
                          arr_last_reading.brand_name || '-'
                        }</span>
                        <span class="badge badge-outline-secondary rounded-1 ms-1" style="color: #A9ABB8;border-color: #A9ABB8;">${
                          arr_last_reading.device_id || '-'
                        }</span>
                        ${battery}
                    </div>
                    ${intensity_per_hour}
                </div>
                ${card_footer}
            </div>
        </div>`;
}

function createDetailPanelStationWQ(reading) {
  var photo = '/images/default-pu.png';

  if (reading.photo != null) {
    var photo = `/uploads/images/stations/${reading.photo}`;
  }
  var device_status =
    '<small class="mdi mdi-circle text-danger"></small> Offline';

  if (reading.status == 'online') {
    device_status =
      '<small class="mdi mdi-circle text-success"></small> Online';
  }

  var panelContent = '<table class="table mb-2 font-12"><tbody>';

  panelContent += '<tr>';
  panelContent += `<td class="px-0 py-2" colspan="3">
                <div class="d-flex align-items-start">
            <img class="me-2 rounded-3" src="${appendImageVersion(photo)}" width="35" height="35" alt="${reading.name}">
                    <div class="w-100">
                        <h5 class="mt-0 mb-1 fw-semibold font-12">${reading.name}</h5>
                        <small class="text-muted">Update Terakhir: ${moment(reading.created_date).locale('id').format('D MMMM YYYY')}</small>  
                    </div>
                </div>
            </td>`;
  panelContent += '</tr>';

  panelContent += '<tr>';
  panelContent += `<td class="py-1 px-0">Skor</td>`;
  panelContent += `<td class="py-1 px-2">:</td>`;
  panelContent += `<td class="py-1 px-0 align-middle">
                ${reading.quality_value != null ? reading.quality_value.toFixed(2) : '-'}
            </td>`;
  panelContent += '</tr>';

  panelContent += '<tr>';
  panelContent += `<td class="py-1 px-0">Kondisi</td>`;
  panelContent += `<td class="py-1 px-2">:</td>`;
  panelContent += `<td class="py-1 px-0 align-middle">${reading.quality_status || '-'}</td>`;
  panelContent += '</tr>';

  panelContent += '<tr>';
  panelContent += `<td class="py-1 px-0">Kelas</td>`;
  panelContent += `<td class="py-1 px-2">:</td>`;
  panelContent += `<td class="py-1 px-0 align-middle">${reading.kelas || '-'}</td>`;
  panelContent += '</tr>';

  panelContent += '<tr>';
  panelContent += `<td class="py-1 px-0">Keterangan</td>`;
  panelContent += `<td class="py-1 px-2">:</td>`;
  panelContent += `<td class="py-1 px-0 align-middle">${reading.keterangan || '-'}</td>`;
  panelContent += '</tr>';

  panelContent += '</tbody></table>';

  return panelContent;
}

function getWaterQualityColor(value) {
  // 1. Handle null, undefined, atau string kosong
  if (!value) return ['#808080', 'wq-normal.svg'];

  // 2. Normalisasi input: ubah ke kecil dan hapus spasi di awal/akhir
  const status = value.toString().toLowerCase().trim();

  // 3. Gunakan switch atau mapping untuk keterbacaan
  switch (status) {
    case 'normal':
      return ['#fff', 'wq-normal.svg']; // Hijau
    case 'cemar ringan':
      return ['#00FF00', 'wq-cemar-ringan.svg']; // Biru
    case 'cemar sedang':
      return ['#FFFF00', 'wq-cemar-sedang.svg']; // Kuning
    case 'cemar berat':
      return ['#E53935', 'wq-cemar-berat.svg']; // Merah
    case 'buruk':
      return ['#E53935', 'wq-cemar-berat.svg']; // Merah
    default:
      // Jika ada nilai string lain yang tidak dikenali
      return ['#808080', 'wq-normal.svg'];
  }
}

// ============================================================
//  HELPER – label status parameter berdasarkan skor 1–4
//  (sesuai field quality_ph, quality_do, quality_cod, quality_bod)
//  Nilai 1 = Baik/Normal, 2 = Sedang, 3 = Waspada, 4 = Tinggi/Buruk
// ============================================================
function getParamStatusFromScore(score) {
  const s = parseInt(score);
  if (s === 1) return { text: 'Normal', cls: 's-normal' };
  if (s === 2) return { text: 'Sedang', cls: 's-sedang' };
  if (s === 3) return { text: 'Waspada', cls: 's-waspada' };
  if (s === 4) return { text: 'Tinggi', cls: 's-tinggi' };
  return { text: '-', cls: '' };
}

// ============================================================
//  HELPER – kategori kualitas air berdasarkan nilai (mirror C#)
// ============================================================
function getWQCategory(value) {
  if (value === null || value === undefined || value < 0)
    return { label: 'Not Recognize', color: '#888888', cls: 'default' };
  if (value <= 1) return { label: 'Baik', color: '#2ecc71', cls: 'baik' };
  if (value <= 5)
    return { label: 'Cemar Ringan', color: '#f1c40f', cls: 'cemar-ringan' };
  if (value <= 10)
    return { label: 'Cemar Sedang', color: '#e67e22', cls: 'cemar-sedang' };
  return { label: 'Cemar Berat', color: '#e74c4c', cls: 'cemar-berat' };
}

function getBadgeClass(kelas) {
  const s = (kelas ?? '').toString().trim().toLowerCase();

  if (s === 'kelas a' || s === 'a') {
    return 'bg-white text-dark border border-secondary';
  }
  if (s === 'kelas b' || s === 'b') {
    return 'bg-success text-white';
  }
  if (s === 'kelas c' || s === 'c') {
    return 'bg-warning text-dark';
  }
  if (s === 'kelas d' || s === 'd') {
    return 'bg-danger text-white';
  }

  return 'bg-secondary text-white';
}

// ============================================================
//  HELPER – label musim dari field season
// ============================================================
function getSeasonLabel(season) {
  if (!season) return { icon: '🌫️', label: 'Tanpa Musim', iconRight: '🌫️' };
  const s = season.toLowerCase();
  if (s === 'dry')
    return { icon: '☀️', label: 'Musim Kemarau', iconRight: '🌵' };
  if (s === 'wet') return { icon: '🌧️', label: 'Musim Hujan', iconRight: '💧' };
  return { icon: '🌫️', label: season, iconRight: '🌫️' };
}

// ============================================================
//  HELPER – bandingkan quality_value dengan data sebelumnya di data_grafik
//  Return: 'up' | 'down' | 'eq'
// ============================================================
function getTrendArrow(dataGrafik, qualityValue) {
  if (!dataGrafik || dataGrafik.length < 2) return 'eq';
  // Sort asc by date, ambil 2 terakhir
  const sorted = [...dataGrafik].sort((a, b) => new Date(a.x) - new Date(b.x));
  const last = sorted[sorted.length - 1].y;
  const prev = sorted[sorted.length - 2].y;
  if (last > prev) return 'up';
  if (last < prev) return 'down';
  return 'eq';
}

// ============================================================
//  HELPER – build HTML satu card stasiun WQ
// ============================================================
function buildWQCard(item) {
  // Tanggal: pakai created_date, fallback ke last_updated
  let dateStr = '-';
  if (item.created_date) {
    dateStr = moment(item.created_date).locale('id').format('YYYY-MM-DD');
  } else if (item.last_updated) {
    const lu = item.last_updated;
    dateStr = `${lu.year}-${String(lu.month).padStart(2, '0')}-${String(lu.day).padStart(2, '0')}`;
  }

  const cat = getWQCategory(item.quality_value);
  const badgeCls = getBadgeClass(item.kelas);
  const badgeLabel = item.keterangan || '-';
  const musim = getSeasonLabel(item.season);
  const trend = getTrendArrow(item.data_grafik, item.quality_value);
  const arrowHtml =
    trend === 'up'
      ? `<span class="arrow-up">&#8593;</span>`
      : trend === 'down'
        ? `<span class="arrow-dwn">&#8595;</span>`
        : `<span class="arrow-eq">&#8212;</span>`;

  // Parameter — pakai skor dari API (quality_ph, quality_do, quality_cod, quality_bod)
  const params = [
    { label: 'pH', score: item.quality_ph, unit: '' },
    { label: 'DO', score: item.quality_do, unit: 'mg/L' },
    { label: 'COD', score: item.quality_cod, unit: 'mg/L O2' },
    { label: 'BOD', score: item.quality_bod, unit: 'mg/L O2' },
  ];

  const hasAnyParam = params.some(
    (p) => p.score !== null && p.score !== undefined,
  );

  const paramsHTML = params
    .map((p) => {
      const hasData = p.score !== null && p.score !== undefined;
      const st = hasData
        ? getParamStatusFromScore(p.score)
        : { text: '-', cls: '' };
      const noDataCls = hasData ? '' : 'no-data';
      return `
        <div class="wq-param ${noDataCls}">
            <div class="p-label">${p.label}</div>
            <div class="p-value">${hasData ? p.score : '-'}<span class="p-unit">${hasData && p.unit ? ' ' + p.unit : ''}</span></div>
            
        </div>`;
    })
    .join('');

  const canvasId = `wq-chart-${item.id}`; // ID dipakai sebagai container Highcharts (div)

  return `
    <div class="wq-card" data-ts-id="${item.id}" id="card-station-${item.id}">

        <!-- Top bar: musim + tanggal -->
        <div class="wq-topbar">
            <div class="wq-season">${musim.icon} ${musim.label} ${musim.iconRight}</div>
            <div class="wq-date">&#128197; ${dateStr}</div>
        </div>

        <!-- Nama stasiun -->
        <div class="wq-location">
            <span class="pin">&#128205;</span>${item.name || '-'}
        </div>

        <!-- Nilai & Status -->
        <div class="wq-nilai-status">
            <div class="wq-nilai">
                <div class="num">
                    ${item.quality_value !== null && item.quality_value !== undefined ? item.quality_value : '-'}
                    ${item.quality_value !== null && item.quality_value !== undefined ? arrowHtml : ''}
                </div>
                <div class="caption">Nilai</div>
            </div>
            <div class="wq-status-block">
                <div class="wq-badge ${badgeCls}">${badgeLabel}</div>
                <div class="wq-status-caption">Status Cemar</div>
            </div>
        </div>

        <!-- Chart + Parameters -->
        <div class="wq-bottom">
            <div class="wq-chart-box">
                <div id="${canvasId}" style="width:100%;height:95px;"></div>
            </div>
            <div class="wq-params">
                ${paramsHTML}
            </div>
        </div>

    </div>`;
}

// ============================================================
//  HELPER – inisialisasi mini chart Highcharts dari data_grafik
//  Format: [ { x: "2025-05-30T00:00:00", y: 9.0 }, ... ]
//  Handle data kosong dengan pesan "Belum ada pencatatan data"
// ============================================================
function initWQChart(containerId, dataGrafik) {
  const container = document.getElementById(containerId);
  if (!container) return;

  const isEmpty = !dataGrafik || dataGrafik.length === 0;

  // Jika kosong: tampilkan pesan
  if (isEmpty) {
    container.innerHTML = `
            <div style="
                height:95px;
                display:flex;
                flex-direction:column;
                align-items:center;
                justify-content:center;
                gap:4px;
                color:#4a5a80;
                font-size:9px;
                text-align:center;
                padding:6px;
            ">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3a4a6a" stroke-width="1.5">
                    <path d="M3 3v18h18"/><path d="M7 16l4-4 4 4 4-6" stroke="#3a4a6a"/>
                </svg>
                <span style="line-height:1.4;">Belum ada<br>pencatatan data</span>
            </div>`;
    return;
  }

  // Konversi & sort asc
  const seriesData = dataGrafik
    .map((d) => ({ ts: new Date(d.x).getTime(), y: d.y }))
    .sort((a, b) => a.ts - b.ts);

  // Light gray agar kontras di background gelap
  const markerColor = '#c8d0e0';
  const pointData = seriesData.map((p) => ({
    x: p.ts,
    y: p.y,
    marker: {
      fillColor: markerColor,
      lineColor: markerColor,
      lineWidth: 0,
      radius: 4,
    },
  }));

  Highcharts.chart(containerId, {
    chart: {
      type: 'scatter',
      backgroundColor: 'transparent',
      margin: [6, 4, 22, 4], // top, right, bottom(ruang xAxis), left
      spacing: [0, 0, 0, 0],
      animation: { duration: 400 },
      style: { fontFamily: 'inherit' },
    },
    title: { text: null },
    subtitle: { text: null },
    credits: { enabled: false },
    legend: { enabled: false },
    exporting: { enabled: false },

    xAxis: {
      type: 'datetime',
      // Interval 1 tahun agar label tidak double
      tickInterval: 365 * 24 * 3600 * 1000,
      lineColor: 'rgba(255,255,255,0.08)',
      tickColor: 'rgba(255,255,255,0.15)',
      tickLength: 3,
      labels: {
        format: '{value:%Y}',
        style: { color: '#ffffff', fontSize: '8px' },
        y: 14,
      },
    },

    yAxis: {
      visible: false,
      maxPadding: 0.25,
    },

    tooltip: {
      backgroundColor: 'rgba(15,24,58,0.96)',
      borderColor: 'rgba(91,168,255,0.35)',
      borderRadius: 7,
      borderWidth: 1,
      shadow: false,
      useHTML: true,
      style: { color: '#ffffff', fontSize: '11px', padding: '0' },
      formatter: function () {
        const cat = getWQCategory(this.y);
        return `
                    <div style="padding:6px 8px;line-height:1.6;">
                        <div style="color:#7eb3ff;font-size:9px;margin-bottom:3px;">
                            ${Highcharts.dateFormat('%d %b %Y', this.x)}
                        </div>
                        <div>Nilai: <b style="color:#fff;">${this.y}</b></div>
                        <div>Status: <b style="color:${cat.color};">${cat.label}</b></div>
                    </div>`;
      },
    },

    plotOptions: {
      scatter: {
        color: markerColor,
        marker: {
          enabled: true,
          radius: 4,
          fillColor: markerColor,
          lineWidth: 0,
          symbol: 'circle',
        },
        states: {
          hover: {
            marker: { enabled: true, radius: 5 },
          },
        },
      },
    },

    series: [
      {
        name: 'Nilai',
        data: pointData,
      },
    ],
  });
}

// ============================================================
//  FUNGSI UTAMA
// ============================================================
function loadContentWaterQuality() {
  $.ajax({
    url: '/Home/GetWaterQualityData',
    type: 'GET',
    dataType: 'json',
    beforeSend: function () {
      // $("#loadingSpinner").show();
    },
    success: function (response) {
      if (!response) return;

      $('#total-wq').text(response.length);

      // 1. Grupkan berdasarkan watershed_id
      const groupedByWatershed = {};
      const noWatershedItems = [];

      response.forEach((item) => {
        if (item.watershed_id) {
          if (!groupedByWatershed[item.watershed_id]) {
            groupedByWatershed[item.watershed_id] = {
              watershed_name: item.watershed_name,
              items: [],
            };
          }
          groupedByWatershed[item.watershed_id].items.push(item);
        } else {
          noWatershedItems.push(item);
        }
      });

      // 2. Bersihkan container utama
      const $mainContainer = $('#wq-accordion-ws-ciliwung-cisadane');
      $mainContainer.empty();

      // 3. Render per watershed (Accordion)
      Object.keys(groupedByWatershed).forEach((watershedId) => {
        const watershed = groupedByWatershed[watershedId];
        const itemCount = watershed.items.length;
        let cardsHTML = '';
        const chartQueue = [];

        watershed.items.forEach((item) => {
          cardsHTML += buildWQCard(item);
          chartQueue.push({
            id: item.id,
            dataGrafik: item.data_grafik ?? [],
            qualityStatus: item.quality_status,
          });

          // Marker peta
          if (item.latitude != null && item.longitude != null) {
            const status = (item.quality_status ?? '').toLowerCase();
            let bg_status = '';
            if (status === 'baik') bg_status = 'alert-siaga3';
            else if (status === 'sedang') bg_status = 'alert-siaga2';
            else if (status === 'buruk') bg_status = 'alert-siaga1';

            const [circleColor, iconFile] = getWaterQualityColor(
              item.quality_status,
            );
            const customIcon = L.divIcon({
              iconSize: [40, 40],
              iconAnchor: [20, 20],
              html: `
                                <div class="ts-marker-wrapper">
                                    <a href="javascript:void(0)" class="ts-marker ts-wq"
                                       data-ts-id="${item.id}" style="text-decoration:none;">
                                        <div class="ts-marker__title">${item.name}</div>
                                        <img src="${appendImageVersion(`/images/water-quality/${iconFile}`)}"
                                             style="display:block;width:40px;height:40px;margin:0 auto;" />
                                    </a>
                                </div>`,
            });
            L.marker([item.latitude, item.longitude], {
              icon: customIcon,
              qualityStatus: item.quality_status,
            })
              .bindPopup(createDetailPanelStationWQ(item))
              .addTo(wq_marker);
          }
        });

        const collapseId = `collapse-wq-${watershedId}`;
        $mainContainer.append(`
                    <div class="card mb-0">
                        <div class="card-header card-header-watershed">
                            <h5 class="m-0 position-relative">
                                <a class="custom-accordion-title d-flex align-items-center"
                                   data-bs-toggle="collapse"
                                   href="#${collapseId}"
                                   aria-expanded="true">
                                    <span style="color:#0ECAF0;font-weight:600;">
                                        #${watershed.watershed_name || 'Tanpa Nama'}
                                    </span>
                                    <span class="ms-auto d-flex align-items-center">
                                        <span class="badge bg-info rounded me-2">${itemCount}</span>
                                        <i class="mdi mdi-chevron-down accordion-arrow" style="color:#D0D1D8;"></i>
                                    </span>
                                </a>
                            </h5>
                        </div>
                        <div id="${collapseId}" class="collapse show">
                            <div class="card-body content-watershed"
                                 style="border-bottom:1px solid #293067; padding:8px;">
                                ${cardsHTML}
                            </div>
                        </div>
                    </div>
                `);

        // Init chart SETELAH elemen masuk ke DOM
        chartQueue.forEach((q) =>
          initWQChart(`wq-chart-${q.id}`, q.dataGrafik, q.qualityStatus),
        );
      });

      // 4. Render item tanpa watershed
      if (noWatershedItems.length > 0) {
        let noWsHTML = '';
        noWatershedItems.forEach((item) => {
          noWsHTML += buildWQCard(item);
        });
        $('#group-wq').html(noWsHTML);

        // Init chart untuk item tanpa watershed
        noWatershedItems.forEach((item) => {
          initWQChart(
            `wq-chart-${item.id}`,
            item.data_grafik ?? [],
            item.quality_status,
          );
        });
      }

      onMarkerLoadComplete();
    },
    error: function (xhr, status, error) {
      console.error('Error load data:', error);
    },
    complete: function () {
      $('#loadingSpinner').hide();
    },
  });
}

//function loadContentWaterQuality() {
//    $.ajax({
//        url: '/Home/GetWaterQualityData',
//        type: 'GET',
//        dataType: 'json',
//        beforeSend: function () {
//            // Optional: $("#loadingSpinner").show();
//        },
//        success: function (response) {
//            if (response) {
//                $("#total-wq").text(response.length);

//                // 1. Grupkan data berdasarkan watershed_id
//                const groupedByWatershed = {};
//                const noWatershedItems = [];

//                response.forEach(item => {
//                    if (item.watershed_id && item.watershed_id !== null && item.watershed_id !== '') {
//                        if (!groupedByWatershed[item.watershed_id]) {
//                            groupedByWatershed[item.watershed_id] = {
//                                watershed_name: item.watershed_name,
//                                items: []
//                            };
//                        }
//                        groupedByWatershed[item.watershed_id].items.push(item);
//                    } else {
//                        noWatershedItems.push(item);
//                    }
//                });

//                // 2. Bersihkan container utama
//                const $mainContainer = $('#wq-accordion-ws-ciliwung-cisadane');
//                $mainContainer.empty();

//                // 3. Render item BERDASARKAN watershed (Accordion)
//                Object.keys(groupedByWatershed).forEach(watershedId => {
//                    const watershed = groupedByWatershed[watershedId];
//                    const itemCount = watershed.items.length;
//                    let watershedContent = '';

//                    watershed.items.forEach(item => {

//                        // Logika Warna Status
//                        const status = (item.quality_status ?? "").toLowerCase();
//                        let bg_status = "";
//                        if (status === "cemar ringan") bg_status = "alert-siaga3";
//                        else if (status === "cemar sedang") bg_status = "alert-siaga2";
//                        else if (status === "cemar berat") bg_status = "alert-siaga1";

//                        // Build HTML Card
//                        watershedContent += `
//                            <div class="card-station-wq" data-ts-id="${item.id}" id="card-station-${item.id}">
//                                <div class="card card-station">
//                                    <div class="card-header">
//                                        <div class="d-flex align-items-center">
//                                            <span class="reading-at"></span>
//                                            <span class="reading-at ms-auto">${moment(item.created_date).locale('id').format('YYYY-MM-DD')}</span>
//                                        </div>
//                                    </div>
//                                    <div class="card-body">
//                                        <div class="w-100">
//                                            <h4 class="card-title text-station-name m-0 mb-2">${item.name}</h4>
//                                        </div>
//                                        <div class="d-flex justify-content-around align-items-center reading-text mb-1">
//                                            <div class="col-4 text-center"><h4>${item.quality_value || '-'}</h4></div>
//                                            <div class="col-4 col-intensity text-center"><h4>${item.quality_status || '-'}</h4></div>
//                                        </div>
//                                        <div class="d-flex justify-content-around reading-text">
//                                            <div class="col-4 text-center">Nilai</div>
//                                            <div class="col-4 text-center fst-italic">Status Cemar</div>
//                                        </div>
//                                    </div>
//                                </div>
//                            </div>`;

//                        // Tambahkan marker ke peta
//                        if (item.latitude != null && item.longitude != null) {
//                            const [circleColor, iconFile] = getWaterQualityColor(item.quality_status);
//                            var customIcon = L.divIcon({
//                                iconSize: [40, 40],
//                                iconAnchor: [20, 20],
//                                html: `
//                                    <div class="ts-marker-wrapper ${bg_status}">
//                                        <a href="javascript:void(0)" class="ts-marker ts-wq" data-ts-id="${item.id}" style="text-decoration:none;">
//                                            <div class="ts-marker__title ">${item.name}</div>
//                                            <img src="/images/water-quality/${iconFile}" style="display:block; width:23px; height:23px; margin:0 auto;" />
//                                        </a>
//                                    </div>`
//                            });
//                            L.marker([item.latitude, item.longitude], { icon: customIcon, qualityStatus: item.quality_status  })
//                                .bindPopup(createDetailPanelStationWQ(item))
//                                .addTo(wq_marker);
//                        }
//                    });

//                    // Append Accordion dengan ID unik agar tidak hilang saat diklik
//                    const collapseId = `collapse-wq-${watershedId}`;
//                    $mainContainer.append(`
//                        <div class="card mb-0">
//                            <div class="card-header card-header-watershed">
//                                <h5 class="m-0 position-relative">
//                                    <a class="custom-accordion-title d-flex align-items-center"
//                                       data-bs-toggle="collapse"
//                                       href="#${collapseId}"
//                                       aria-expanded="true">
//                                        <span style="color: #0ECAF0; font-weight: 600;">#${watershed.watershed_name || 'Tanpa Nama'}</span>
//                                        <span class="ms-auto d-flex align-items-center">
//                                            <span class="badge bg-info rounded me-2">${itemCount}</span>
//                                            <i class="mdi mdi-chevron-down accordion-arrow" style="color: #D0D1D8;"></i>
//                                        </span>
//                                    </a>
//                                </h5>
//                            </div>
//                            <div id="${collapseId}" class="collapse show">
//                                <div class="card-body content-watershed" style="border-bottom: 1px solid #293067; padding: 0;">
//                                    ${watershedContent}
//                                </div>
//                            </div>
//                        </div>
//                    `);
//                });

//                // 4. Render item TANPA watershed
//                if (noWatershedItems.length > 0) {
//                    let noWatershedContent = '';
//                    noWatershedItems.forEach(item => {
//                        noWatershedContent += `
//                            <div class="card-station-wq" data-ts-id="${item.id}">
//                                <div class="card card-station mb-1">
//                                    <div class="card-body"><h4 class="text-station-name">${item.name}</h4></div>
//                                </div>
//                            </div>`;
//                    });
//                    $("#group-wq").html(noWatershedContent);
//                }
//            }
//            onMarkerLoadComplete();
//        },
//        error: function (xhr, status, error) {
//            console.error("Error load data:", error);
//        },
//        complete: function () {
//            $("#loadingSpinner").hide();
//        }
//    });
//}

/**
 * Fungsi utama filter: menyembunyikan/menampilkan card berdasarkan keyword
 * Bekerja di tab aktif saja.
 * @param {string} keyword - teks pencarian dari input
 */
function filterSidebarCards(keyword) {
  const q = keyword.toLowerCase().trim();

  // Deteksi tab aktif
  const activeTab = $('#tab-center-left .nav-link.active').attr('href'); // e.g. "#tab-awlr"

  if (activeTab === '#tab-awlr') {
    filterAwlrCards(q);
  } else if (activeTab === '#tab-arr') {
    filterArrCards(q);
  } else if (activeTab === '#tab-wq') {
    filterWqCards(q);
  } else if (activeTab === '#tab-cctv') {
    filterCctvCards(q);
  }
}

// -----------------------------------------------------------
// Filter PDA (AWLR)
// Struktur: .card-station-awlr > .card > .card-body > .text-station-name
//           device ID ada di .badge-outline-secondary
// Accordion: #awlr-watershed-{id} .content-watershed
// -----------------------------------------------------------
function filterAwlrCards(q) {
  // Loop semua card awlr
  $('#tab-awlr .card-station-awlr').each(function () {
    const name = $(this).find('.text-station-name').text().toLowerCase();
    const deviceId = $(this)
      .find('.badge-outline-secondary')
      .text()
      .toLowerCase();
    const match = !q || name.includes(q) || deviceId.includes(q);
    $(this).toggle(match);
  });

  // Setelah filter card, cek tiap accordion watershed:
  // Jika tidak ada card yang terlihat di dalam watershed tersebut → sembunyikan accordion-nya
  $('#tab-awlr .card.mb-0').each(function () {
    const hasVisible = $(this).find('.card-station-awlr:visible').length > 0;
    $(this).toggle(hasVisible);
  });

  // Juga cek header river-area (h4 dengan id awlr-river-area-*)
  $('[id^="awlr-river-area-"]').each(function () {
    const riverAreaId = $(this).attr('id').replace('awlr-river-area-', '');
    const accordion = $(`#awlr-accordion-${riverAreaId}`);
    const hasVisible =
      accordion.find('.card-station-awlr:visible').length > 0 ||
      accordion.find('.card.mb-0:visible').length > 0;
    $(this).toggle(hasVisible);
    accordion.toggle(hasVisible);
  });

  // Jika tidak ada filter, pastikan semua accordion terbuka kembali
  if (!q) {
    $('#tab-awlr .card.mb-0').show();
    $('[id^="awlr-river-area-"]').show();
    $('[id^="awlr-accordion-"]').show();
  }
}

// -----------------------------------------------------------
// Filter PCH (ARR)
// Struktur mirip AWLR, tapi class .card-station-arr
// Accordion: #arr-watershed-{id}
// -----------------------------------------------------------
function filterArrCards(q) {
  $('#tab-arr .card-station-arr').each(function () {
    const name = $(this).find('.text-station-name').text().toLowerCase();
    const deviceId = $(this)
      .find('.badge-outline-secondary')
      .text()
      .toLowerCase();
    const match = !q || name.includes(q) || deviceId.includes(q);
    $(this).toggle(match);
  });

  $('#tab-arr .card.mb-0').each(function () {
    const hasVisible = $(this).find('.card-station-arr:visible').length > 0;
    $(this).toggle(hasVisible);
  });

  $('[id^="arr-river-area-"]').each(function () {
    const riverAreaId = $(this).attr('id').replace('arr-river-area-', '');
    const accordion = $(`#arr-accordion-${riverAreaId}`);
    const hasVisible =
      accordion.find('.card-station-arr:visible').length > 0 ||
      accordion.find('.card.mb-0:visible').length > 0;
    $(this).toggle(hasVisible);
    accordion.toggle(hasVisible);
  });

  if (!q) {
    $('#tab-arr .card.mb-0').show();
    $('[id^="arr-river-area-"]').show();
    $('[id^="arr-accordion-"]').show();
  }
}

// -----------------------------------------------------------
// Filter Kualitas Air (WQ)
// Struktur: .wq-card dengan nama di .wq-location dan status di .wq-badge
// Accordion: #collapse-wq-{watershedId}
// -----------------------------------------------------------
function filterWqCards(q) {
  $('#tab-wq .wq-card').each(function () {
    const name = $(this).find('.wq-location').text().toLowerCase();
    const status = $(this).find('.wq-badge').text().toLowerCase();
    const season = $(this).find('.wq-season').text().toLowerCase();
    const match =
      !q || name.includes(q) || status.includes(q) || season.includes(q);
    $(this).toggle(match);
  });

  // Sembunyikan accordion watershed jika tidak ada card yang cocok
  $('#wq-accordion-ws-ciliwung-cisadane .card.mb-0').each(function () {
    const hasVisible = $(this).find('.wq-card:visible').length > 0;
    $(this).toggle(hasVisible);
  });

  if (!q) {
    $('#tab-wq .wq-card').show();
    $('#wq-accordion-ws-ciliwung-cisadane .card.mb-0').show();
  }
}

// -----------------------------------------------------------
// Filter CCTV
// Struktur: .cctv-thumbnail-wrapper dengan data-cctv-name
// -----------------------------------------------------------
function filterCctvCards(q) {
  const query = (q || '').toLowerCase().trim();

  $('#image-cctv .cctv-card-wrapper').each(function () {
    const name = $(this).attr('data-cctv-name') || '';
    const match = !query || name.toLowerCase().includes(query);
    $(this).css('display', match ? '' : 'none'); // none bukan block!
  });

  if (!query) {
    $('#image-cctv .cctv-card-wrapper').css('display', '');
  }
}
